/* Language pack: en */
export const translationsEn = {
	chatDropFiles: "Drop files here to attach",
	resumeRecording: "Resume",
	chatCallMissed: "Missed",
	chatCallDeclined: "Declined",
	chatAudioConference: "Audio conference",
	chatVideoConference: "Video conference",

	chatHistoryBeginning: "Beginning of conversation",
	chatHistoryEmpty: "No messages yet",
	chatHistoryLoadFailed: "Could not load chat history.",
	personalTime: "Company-provided time off",
	hrPersonalHoursPerYear: "Time off allowance (hours per year)",
	hrPersonalHoursHint: "Annual allowance for late arrivals, early departures and absences. Resets each calendar year; unused hours do not carry over.",
	absenceDays: "Days",
	absenceHours: "Hours",
	absenceUnit: "Record absence in",
	absenceRequest: "Request time off",
	absenceRequestHint: "Select past dates to cover missed time or future dates to request time off. The balance is deducted after approval.",
	absenceRequestSaved: "Request submitted for approval",
	absenceAvailable: "Remaining",
	absenceUsed: "Used / booked",
	sickBalanceDays: "Remaining sick days",
	personalBalanceHours: "Remaining company hours",
	absenceBalanceHint: "Approved future absences are included in used time. Cancelling or deleting an entry restores its balance.",

	IDCardImages: "ID card images",
	IT: "IT",
	Status: "Status",
	abbreviation: "Abbreviation",
	aboutUsItems: "About Us Items",
	absent: "Absent",
	absentDays: "Absent Days",
	accept: "Accept",
	actSendingDate: "Act sending date",
	actionTimestamp: "Action timestamp",
	actionType: "Action type",
	actions: "Actions",
	activateStep7_8_9: "Assignment to the Department of Power Transmission Lines ( 7, 8, 9 )",
	activateStep8: "Assignment to the geodetic department ( 8 )",
	activatedProjects: "Activated Projects",
	active: "Active",
	activeCarts: "Active Carts",
	activeClients: "Active Clients",
	activeCustomers: "Active Customers",
	activeProjectSteps: "Active project steps",
	activePromos: "Active Promotions",
	activeSales: "Active Sales",
	activeSalesEvents: "Active Sales Events",
	activeServices: "active services",
	activeSteps: "Active steps",
	activeStreams: "Active Streams",
	activeTasks: "Active tasks",
	activeTime: "Active time",
	activity: "Activity",
	activityTimes: "Activity times",
	activityLoadFailed: "Could not load user activity for this day.",
	noActivityForDay: "No activity recorded for this day.",
	currentInactivity: "Current inactivity",
	userActivityHistory: "User activity (last 7 days)",
	actualHours: "Actual Hours",
	adInterval: "Ad interval",
	adIntervalOverride: "Ad interval override",
	adIntervalOverrideDesc: "Ad interval override description",
	adIntervalOverrideValue: "Ad interval override value",
	adPlaylist: "Ad playlist",
	adPlaylists: "Ad Playlists",
	adTracks: "Advertisement Tracks",
	add: "Add",
	addAttendance: "Add Attendance",
	addFeature: "Add feature",
	addFeatureLine: "Add feature line",
	addFiles: "Add files",
	addMoreFiles: "Add more files",
	addNew: "Add New",
	addPriceLine: "Add price line",
	addRule: "Add rule",
	startChat: "Start chat",
	addToList: "Add to list",
	addVacationInterval: "Add vacation interval",
	added: "Added",
	additionalDetails: "Additional Details",
	address: "Address",
	addressData: "Address Data",
	assignedEmployee: "Assigned employee",
	advanceDeductions: "Advance Deductions",
	advertisement: "Advertisement",
	age: "Age",
	ageGroups: "Age Groups",
	ago: "ago",
	agreedProjects: "Agreed Projects",
	agreementAquipment: "Agreement on equipment",
	aiConversations: "Conversations",
	album: "Album",
	allArtists: "all artists",
	allAudioTracks: "all audio tracks",
	allContentItems: "all content items",
	allFilesDeleted: "All files have been permanently deleted",
	allFilesWillBeDeleted: "All files will be permanently deleted",
	allPlaylists: "all playlists",
	allRegisteredContacts: "all registered contacts",
	allTickets: "All Tickets",
	amount: "Amount",
	analytics: "Analytics",
	answer: "Answer",
	apartment: "Apartment",
	apply: "Apply",
	appsMenu: "Apps menu",
	approved: "Approved",
	approvedInterval: "Approved interval",
	archive: "Archive",
	archived: "Archived",
	areYouSure: "Are you sure?",
	areYouSureToDelete: "Are you sure you want to delete this?",
	arrived: "arrived",
	artist: "Artist",
	artistObject: "Artist object",
	assignedTo: "Assigned To",
	assignedToUser: "Assigned To",
	assignmentToTheConstructionDepartment: "Assignment to the construction department",
	attach: "Attach",
	attachFile: "Attach file",
	attachments: "Attachments",
	automationCenterAction: "Action",
	automationCenterActionResults: "Action results",
	automationCenterActions: "Actions",
	automationCenterActionsCount: "{count} action(s)",
	automationCenterActiveRules: "Active rules ({count})",
	automationCenterAddAction: "Add action",
	automationCenterAddCondition: "Add condition",
	automationCenterAvailableFields: "Available fields: {fields}",
	automationCenterCancel: "Cancel",
	automationCenterClearFilters: "Clear filters",
	automationCenterColActions: "Actions",
	automationCenterColDuration: "Duration",
	automationCenterColEvent: "Event",
	automationCenterColLastRun: "Last run",
	automationCenterColManage: "Manage",
	automationCenterColName: "Name",
	automationCenterColRule: "Rule",
	automationCenterColRuleActions: "Rule actions",
	automationCenterColRuleName: "Rule name",
	automationCenterColStatus: "Status",
	automationCenterColTimestamp: "Timestamp",
	automationCenterColTriggeredAt: "Triggered at",
	automationCenterColTrigger: "Trigger",
	automationCenterConditionsOptional: "Conditions (optional)",
	automationCenterCreateRule: "Create rule",
	automationCenterCreateRuleButton: "Create rule",
	automationCenterDeleted: "Deleted",
	automationCenterDescription: "Description",
	automationCenterDescriptionPlaceholder: "What does this rule do?",
	automationCenterDisabled: "Disabled",
	automationCenterDomain: "Domain",
	automationCenterDomainFinance: "Finance",
	automationCenterDomainHr: "HR",
	automationCenterDomainIt: "IT",
	automationCenterDomainTicket: "Ticket",
	automationCenterEdit: "Edit",
	automationCenterEditRule: "Edit rule",
	automationCenterEnabled: "Enabled",
	automationCenterError: "Error",
	automationCenterEvent: "Event",
	automationCenterExecutionLogs: "Execution logs",
	automationCenterFailed: "Failed",
	automationCenterFailedDeleteRule: "Failed to delete rule",
	automationCenterField: "Field",
	automationCenterFillRequiredFields:
		"Please fill in all required fields and add at least one action",
	automationCenterFilterByStatus: "Filter by status",
	automationCenterLogTitle: "Log: {name}",
	automationCenterNewRule: "New rule",
	automationCenterNoExecutionLogsYet: "No execution logs yet.",
	automationCenterNone: "none",
	automationCenterNoLogsFound: "No logs found.",
	automationCenterNoRulesYet: "No automation rules yet. Create your first rule!",
	automationCenterNoUsersFound: "No users found",
	automationCenterNoDepartmentsFound: "No departments found",
	automationCenterSearchSelectDepartments: "Search and select departments",
	automationCenterOperator: "Operator",
	automationCenterOperatorContains: "contains",
	automationCenterOperatorIn: "in",
	automationCenterParameters: "Parameters",
	automationCenterPartial: "Partial",
	automationCenterPriorityCritical: "Critical",
	automationCenterPriorityHigh: "High",
	automationCenterPriorityLow: "Low",
	automationCenterPriorityMedium: "Medium",
	automationCenterRecentExecutions: "Recent executions",
	automationCenterRefresh: "Refresh",
	automationCenterRuleDeletedSuccess: "Rule deleted successfully",
	automationCenterRuleName: "Rule name",
	automationCenterRuleNamePlaceholder: "e.g., Employee on vacation",
	automationCenterRuleSavedSuccess: "Rule saved successfully!",
	automationCenterSearchSelectUsers: "Search and select users",
	automationCenterSelectAction: "Select action",
	automationCenterSelectActionToExecute: "Select action to execute",
	automationCenterSelectDomain: "Select domain",
	automationCenterSelectEvent: "Select event",
	automationCenterSelectTriggerEvent: "Select the event that triggers this rule",
	automationCenterStatus: "Status",
	automationCenterStatusFailed: "Failed",
	automationCenterStatusPartial: "Partial",
	automationCenterStatusSuccess: "Success",
	automationCenterSuccess: "Success",
	automationCenterThen: "Then...",
	automationCenterTitle: "Automation center",
	automationCenterTotalExecutions: "Total executions",
	automationCenterTriggerEvent: "Trigger event",
	automationCenterTriggerPayload: "Trigger payload",
	automationCenterUpdateRule: "Update rule",
	automationCenterValue: "Value",
	automationCenterView: "View",
	automationCenterWhen: "When...",
	attendance: "Attendance",
	attendanceFlag: "Attendance status",
	attendanceRequiringAttention: "Employees Requiring Attention",
	attendanceNoAttentionItems: "No employees requiring attention",
	attendanceMissingCheckIn: "Missing check-in",
	attendanceMissingCheckOut: "Missing check-out",
	attendanceEarlyLeave: "Early leave",
	attendanceEarlyMissings: "Early missings",
	attendanceEarlyMissingHours: "Early missing hours",
	attendanceLateHours: "Late hours",
	attendanceShowWorkedHours: "Show worked hours",
	attendanceUnapprovedAbsence: "Unapproved absence",
	attendanceDeptAttendance: "Department Attendance",
	attendanceDeviceHealth: "Device Health & Live Sync",
	attendanceLastSync: "Last sync",
	attendanceLiveFeed: "Live Attendance Feed",
	attendanceLiveUsers: "Live Users",
	attendanceLiveTab: "Live",
	attendanceInOffice: "In Office",
	attendanceLiveInApit: "Live in APIT",
	attendanceUsersInOfficeNow: "users in the office right now",
	attendanceLiveInApitNow: "users live in APIT right now",
	attendanceNoOneInOffice: "No one is in the office right now",
	attendanceNoLiveInApit: "No one is live in APIT right now",
	attendanceNoRecentPunches: "No recent punches",
	attendanceManualEntryTag: "Manual",
	attendanceUnmappedPunch: "Unmapped",
	attendancePendingItems: "pending",
	attendanceTrendPctOfEmployeesPresent: "% of employees present",
	yesterday: "Yesterday",
	attendanceFilterThisWeek: "This Week",
	attendanceFilterThisMonth: "This Month",
	attendanceFilterCustom: "Custom",
	attendanceSelectRange: "Select range",
	attendanceCustomRangeCapped: "Custom range is capped at 90 days",
	attendanceLiveBadge: "LIVE",
	attendanceTitleToday: "Today's Attendance",
	attendanceTitleYesterday: "Yesterday's Attendance",
	attendanceTitleThisWeek: "This Week's Attendance",
	attendanceTitleThisMonth: "This Month's Attendance",
	attendanceTitleCustom: "Custom Period Attendance",
	attendanceTitleTodayKpis: "Today's Attendance KPIs",
	attendanceTitleYesterdayKpis: "Yesterday's Attendance KPIs",
	attendanceTitleThisWeekKpis: "This Week's Attendance KPIs",
	attendanceTitleThisMonthKpis: "This Month's Attendance KPIs",
	attendanceTitleCustomKpis: "Custom Period Attendance KPIs",
	attendanceTrendDays: "Attendance Trend — Last {n} Days",
	attendanceNotAttendedYet: "Not Attend Yet",
	attendanceUpcomingAbsences: "Upcoming Absences",
	attendanceUpcomingAbsencesEmpty: "No upcoming absences",
	attendanceUpcomingAbsencesTomorrow: "Tomorrow",
	attendanceUpcomingAbsencesInDays: "In {days} days",
	attendanceExceptions: "Attendance Exceptions",
	attendanceExceptionsMissingCheckIn: "Missing Check-ins",
	attendanceExceptionsMissingCheckOut: "Missing Check-outs",
	attendanceExceptionsEarlyLeaves: "Early Leaves",
	attendanceExceptionsUnapprovedAbsences: "Unapproved Absences",
	attendanceExceptionsDuplicatePunches: "Duplicate Punches",
	attendanceMonthlyKpis: "Monthly Attendance KPIs",
	attendanceKpiRate: "Attendance Rate",
	attendanceKpiAvgArrival: "Average Arrival",
	attendanceKpiLateArrivals: "Late Arrivals",
	attendanceKpiAbsentDays: "Absent Days",
	attendanceKpiOvertimeHours: "Overtime Hours",
	attendanceLeaveBalanceOverview: "Leave Balance Overview",
	attendanceLeaveBalanceVacationRemaining: "Vacation Remaining",
	attendanceLeaveBalanceSickUsed: "Sick Leave Used",
	attendanceLeaveBalanceBusinessTrips: "Business Trips",
	attendanceLeaveBalancePendingRequests: "Pending Requests",
	attendanceLeaveBalanceCoverage: "{covered} of {total} employees",
	attendanceTopInsights: "Top Attendance Insights",
	attendanceInsightNoData: "No insights available yet",
	attendanceInsightHighestLateness: "{dept} has the highest lateness this week ({delta})",
	attendanceInsightFullAttendanceToday: "{dept} has 100% attendance",
	attendanceInsightTrendImproved: "Attendance improved {pct}% vs the previous period",
	attendanceInsightTrendDeclined: "Attendance declined {pct}% vs the previous period",
	attendanceInsightApproachingOvertime: "{count} employees are approaching their overtime limit",
	attendancePreviousWeek: "Last Week",
	attendanceCurrentWeek: "This Week",
	attendanceAddInterval: "Add interval",
	attendanceBreakLabel: "Break",
	attendanceCorrectionMode: "Correction mode",
	attendanceCoveredLabel: "Covered",
	attendanceCustomIntervals: "Custom intervals",
	attendanceDashboard: "Attendance Dashboard",
	attendanceReports: "Reports",
	attendanceCalendarTab: "Calendar",
	reports: "Reports",
	shiftCoverage: "Shift coverage",
	previousPeriod: "Previous period",
	nextPeriod: "Next period",
	failedToSave: "Could not save the overtime comment",
	expandForDailyDetail: "Expand row for daily detail",
	noDataForPeriod: "No data for this period",
	attendanceHistory: "Attendance history",
	attendanceDayOffTab: "Day off",
	attendanceDayType: "Day Type",
	attendanceDetectedIntervals: "Detected intervals",
	attendanceEditDay: "Edit Day",
	attendanceHrsTotal: "hrs total",
	attendanceViewWeek: "Week",
	attendanceViewMonth: "Month",
	attendanceViewDay: "Day",
	day: "Day",
	attendanceOpenFrom: "Open from {time}",
	attendanceFromStillActive: "From {time} → still active",
	attendanceTotalWorked: "Total worked",
	attendanceMissingUncovered: "Missing / uncovered",
	attendanceNoData: "No data",
	attendanceNoDataForDay: "No attendance data for this day.",
	attendanceIntervalApprovedOk: "Approved / OK",
	attendanceIntervalEachRowInvalid: "Please provide valid start and end time for every interval",
	attendanceIntervalTimesInvalid: "Please provide valid start and end time",
	attendanceIntervalsMode: "Intervals",
	attendanceIntervalsReviewHint:
		"Review the actual worked, PTO, and missing intervals. Add manual resolution intervals below to mark them as approved, work, remote, sick leave, vacation, unpaid, or other.",
	attendanceLogSubtitle: "Manual attendance entry — work, sick days, vacation",
	attendanceLogTitle: "Attendance Log",
	attendanceManualResolutionIntervals: "Manual resolution intervals",
	attendanceMissingLabel: "Missing",
	attendanceNoManualIntervalsYet: "No manual intervals added yet",
	attendanceNoUncovered: "No uncovered intervals detected",
	attendanceOptionalNotePlaceholder: "Optional note…",
	attendancePtoLeaveSection: "PTO / Leave",
	attendanceReport: "Attendance Report",
	attendanceResolveInterval: "Resolve this interval",
	attendanceResyncTooltip: "Resync attendance for this employee",
	attendanceResyncSuccess: "Attendance resync started",
	attendanceResyncFailed: "Attendance resync failed",
	attendanceSavedSuccess: "Attendance saved successfully",
	attendanceStatusOnTime: "On time",
	attendanceStatusLate: "Late",
	attendanceStatusAbsent: "Absent",
	attendanceStatusUpcoming: "Upcoming",
	attendanceStatusPeriodWorkingDaysHint:
		"The status is applied to working days in the selected period.",
	attendanceNoWorkingDaysInPeriod: "The selected period has no working days.",
	attendanceStatusPto: "Leave / PTO",
	attendanceStatusPartial: "Partial",
	attendanceStatusOpen: "Open",
	attendanceStatusWeekend: "Weekend",
	attendanceStatusHoliday: "Holiday",
	attendanceStatusNonWorking: "Non-working",
	attendanceSelectEmployeePrompt: "Select an employee to view attendance",
	attendanceTrend: "Attendance Trend",
	attendanceTrendPctPresent: "% Present",
	attendanceUncoveredMissing: "Uncovered / Missing",
	attendanceUnsavedChanges: "Unsaved changes",
	attendanceWholeDayStatus: "Whole day status",
	shiftWorker: "Shift worker",
	attendanceStatusShift: "Shift",
	attendanceIgnoreMode: "Ignore",
	attendanceIgnoreScopeWeekdays: "Weekdays",
	attendanceIgnoreScopeDateRange: "Date range",
	attendanceIgnoreScopeWeekdaysHint: "Applies only on the selected weekdays within this period.",
	attendanceIgnoreScopeDateRangeHint: "Applies to every day in this period.",
	attendanceIgnoreAppliesTo: "Applies to",
	attendanceIgnoreLateArrival: "Late arrival",
	attendanceIgnoreEarlyLeave: "Early leave",
	attendanceIgnoreWindowStart: "Ignore window start",
	attendanceIgnoreWindowEnd: "Ignore window end",
	attendanceIgnoreRulesList: "Ignore rules",
	attendanceIgnoreRulesEmpty: "No ignore rules yet",
	attendanceIgnoreDaysOfWeekRequired: "Select at least one weekday",
	attendanceIgnoredLabel: "Ignored",
	attendanceNoCardLabel: "No Card",
	attendanceWork: "Work",
	attendanceWorked: "Worked",
	attendanceWorkedIntervals: "Worked intervals",
	attendanceMissingIntervals: "Missing intervals",
	attendanceStillInOffice: "Still in office",
	attendanceAddEvent: "Add event",
	attendanceAutoClosed: "Auto-closed",
	attendanceAutoClosedAt: "Automatically closed at {time}",
	automaticEvent: "Automatic event",
	attendanceAddAttendanceEvent: "Add attendance event",
	attendanceDeleteEventTitle: "Delete attendance event?",
	attendanceDeleteEventText: "This removes only this manually added punch event.",
	attendanceNoMissingIntervals: "No missing intervals for this day",
	attendanceOfficeSince: "Since {time}",
	attendanceLastOutAt: "Last out {time}",
	attendanceEventSingular: "event",
	attendanceEventPlural: "events",
	attendancePunchIn: "In",
	attendancePunchOut: "Out",
	solveThis: "Solve this",
	editSolvedStatus: "Edit solved status",
	officeStatus: "Office status",
	outOfOffice: "Out of office",
	noPunches: "No punches",
	lastActionWasCheckIn: "Last action was check in",
	lastActionWasCheckOut: "Last action was check out",
	noCheckInYet: "No check in yet",
	manual: "Manual",
	resolved: "Resolved",
	attendanceManualStatusApplyTicketTimeTo: "Apply ticket time to",
	attendanceManualStatusColumnAttendanceType: "Attendance type",
	attendanceManualStatusColumnTimeAction: "Time action",
	attendanceManualStatusMapsToType: "Maps to attendance type",
	attendanceManualStatusTicketTimeAction: "Ticket automation time action",
	attendanceTicketTimePhraseAdd: "Add {type} time",
	attendanceTicketTimePhraseSubtract: "Subtract {type} time",
	attendanceTimeOpAdd: "Add ticket time",
	attendanceTimeOpNone: "No time balance change",
	attendanceTimeOpSubtract: "Subtract ticket time",
	attendanceTypeOptionAbsent: "Absent",
	attendanceTypeOptionBusinessTrip: "Business Trip",
	attendanceTypeOptionHolidayNonWorking: "Holiday / non-working",
	attendanceTypeOptionJustifiedAbsence: "Justified absence (excused)",
	attendanceTypeOptionMaternity: "Maternity leave",
	attendanceTypeOptionPaidVacation: "Paid vacation",
	attendanceTypeOptionRemote: "Remote work",
	attendanceTypeOptionSickLeave: "Sick leave",
	attendanceTypeOptionUnjustifiedAbsence: "Unjustified absence (unexcused)",
	attendanceTypeOptionUnpaidLeave: "Unpaid leave",
	attendanceTypeOptionWork: "Work",
	audio: "Audio",
	autoDeletion: "Auto-deletion",
	averageDailyHours: "Average daily hours",
	avgDaily: "Avg Daily",
	avgDailyHours: "Avg Daily Hours",
	avgHoursPerWorkingDay: "Avg hours per working day",
	avgOrderValue: "Average Order Value",
	avgResolutionTime: "Avg Resolution Time",
	avgResponseTime: "Avg Response Time",
	avgTracksPerPlaylist: "Avg Tracks/Playlist",
	back: "Back",
	bank: "Bank",
	bankAccount: "Bank Account",
	bankCart: "Bank Card",
	bankEmitet: "Bank",
	banner: "Banner",
	baseSalary: "Base Salary",
	baseSalaryHourlyLinked: "Updates hourly rate from base ÷ regular hours (when regular hours > 0).",
	basicInformation: "Basic Information",
	beginningOfAcquaintance: "Beginning of Acquaintance",
	beginningOfContract: "Beginning of Contract",
	beginningOfTraining: "Beginning of Training",
	benefits: "Benefits",
	bestSeller: "Best seller",
	bestSellers: "Best Sellers",
	bestSellingItemsByRevenue: "Best Selling Items by Revenue",
	bitrate: "Bitrate",
	biweekly: "Biweekly",
	blogItems: "Blog Items",
	blogs: "Blogs",
	bonuses: "Bonuses",
	bpm: "BPM",
	branch: "Branch",
	storeBranches: "Branches",
	storeBranchName: "Branch name",
	storeBranchLatitude: "Latitude",
	storeBranchLongitude: "Longitude",
	storeBranchLoadError: "Unable to load this branch.",
	branches: "Branch list",
	branchesCitiesVillages: "Branches, Cities, Villages",
	brand: "Brand",
	brands: "Brands",
	building: "Building",
	boughtDate: "Bought date",
	broken: "Broken",
	businessTrip: "Business trip",
	buttonText: "Button text",
	bypassSteps: "Bypass Steps",
	calAddCalendarTooltip: "Create a calendar and share it with teammates",
	calAddEvent: "Add event",
	calAddReminder: "Add reminder",
	calAlarm15m: "15 minutes before",
	calAlarm1d: "1 day before",
	calAlarm1h: "1 hour before",
	calAlarm1w: "1 week before",
	calAlarm2d: "2 days before",
	calAlarm2h: "2 hours before",
	calAlarm30m: "30 minutes before",
	calAlarm5m: "5 minutes before",
	calAlarmAtEvent: "At time of event",
	calAllDay: "All day",
	calApiNotConfigured: "Calendar API is not configured.",
	calCalendarColorLabel: "Calendar color",
	calCalendarCreateFailed: "Could not create calendar",
	calCalendarCreated: "Calendar created",
	calCalendarDeleted: "Calendar deleted",
	calCalendarNameLabel: "Calendar name",
	calCalendarNamePh: "e.g. Team planning",
	calCalendarNameRequired: "Enter a calendar name",
	calCalendarSelect: "Calendar",
	calCalendarUpdateFailed: "Could not update calendar",
	calCalendarUpdated: "Calendar updated",
	calCalendarsLabel: "Calendars:",
	calGoogleCalendarLabel: "Google Calendar:",
	calGoogleCalendarPrefix: "Google",
	calMeetingsLabel: "Meetings:",
	calCancel: "Cancel",
	calCheckAll: "Check All",
	calColor: "Color",
	calCreateCalendar: "Create calendar",
	calDay: "Day",
	calDayOverviewTitle: "Day",
	calDefaultCalendarName: "Calendar",
	calDelete: "Delete",
	calDeleteCalendarHasEvents:
		"This calendar has {count} event(s). What would you like to do with them?",
	calDeleteCalendarNoEvents: "This action cannot be undone.",
	calDeleteCalendarOnly: "Delete calendar only",
	calDeleteCalendarTitle: "Delete calendar?",
	calDeleteCalendarWithEvents: "Delete with events",
	calDeleteEventText: "This action cannot be undone.",
	calDeleteEventTitle: "Delete event?",
	calDeleteFailed: "Delete failed",
	calDescription: "Description",
	calDescriptionPh: "Optional description",
	calEditCalendarTitle: "Edit calendar",
	calEditCalendarTooltip: "Edit calendar",
	calEditEvent: "Edit event",
	calEditTooltip: "Edit",
	calEnd: "End",
	calEndBeforeStart: "End date cannot be before start date",
	calEndTime: "End time",
	calEvent: "Event",
	calEventCreated: "Event created",
	calEventDeleted: "Event deleted",
	calEventDetails: "Event details",
	calEventTarget: "Target",
	calEventTitle: "Title",
	calEventTitlePh: "Event title",
	calEventUpdated: "Event updated",
	calEventsPlural: "events",
	calExportIcs: "Export .ics",
	calFailedLoadEvents: "Failed to load events",
	calHrBirthdayEvent: "Birthday",
	calHrBirthdays: "Birthdays",
	calHrContractEnd: "Contract End",
	calHrContractEndEvent: "Contract End",
	calHrContractStart: "Contract Start",
	calHrContractStartEvent: "Contract Start",
	calHrIdEvent: "ID Expiry",
	calHrIdExpiry: "ID Expiry",
	calHrPassportEvent: "Passport Expiry",
	calHrPassportExpiry: "Passport Expiry",
	calHrPositionReview: "Position Review",
	calHrPositionReviewEvent: "Position Review",
	calHrSalaryReview: "Salary Review",
	calHrSalaryReviewEvent: "Salary Review",
	calImportButton: "Import",
	calImportEventsTitle: "Import events",
	calImportFoundInFile: "found in the file. Select a calendar to import them into:",
	calImportIcs: "Import .ics",
	calImportedEventTitle: "Imported event",
	calItLabel: "IT:",
	calItWarrantyEnd: "Warranty Ending",
	calItWarrantyEndEvent: "Warranty Ending",
	calLinkedTo: "Linked to",
	calLocation: "Location",
	calMonth: "Month",
	calNewCalendarTitle: "New calendar",
	calNewEvent: "New event",
	calNoCalendar: "No calendar",
	calNoCalendarUncategorised: "No calendar (uncategorised)",
	calNoEventsInIcs: "No events found in the .ics file",
	calNoEventsThisDay: "No events this day.",
	calNoRemindersThisDay: "No reminders this day.",
	calDayWeatherMap: "Weather map",
	calDayHourlyForecast: "Hourly forecast",
	calDayWeatherUnavailable: "Forecast unavailable for this date",
	calDayEventsSection: "Events",
	calDayRemindersSection: "Reminders",
	calOpenAttendance: "Open attendance",
	calOpenEventLink: "Open link",
	calOpenMeeting: "Open meeting",
	calOpenPc: "Open PC",
	calOpenProfile: "Open profile",
	calOpenRelatedItem: "Open related item",
	calOpenReminderTarget: "Open reminder target",
	calOpenTask: "Open task",
	calOpenTicket: "Open ticket",
	calOpenUser: "Open user",
	calPeopleLabel: "People:",
	calReminders: "Reminders",
	calRemindersLabel: "Reminders:",
	calAttendanceLabel: "Attendance:",
	calSecurityLabel: "Security:",
	calSecurityAlerts: "Alerts",
	calSecuritySessions: "Sessions",
	calSecurityTokenExpiry: "Token Expiry",
	calRemindersToggle: "Active reminders",
	calSave: "Save",
	calSaveFailed: "Save failed",
	calShareWithUsers: "Share with users",
	calShareWithUsersPh: "Search and select people",
	calStart: "Start",
	calStartEndRequired: "Start and end time required",
	calStartTime: "Start time",
	calSwalDelete: "Delete",
	calTaskHigh: "High",
	calTaskLow: "Low",
	calTaskMedium: "Medium",
	calTaskUrgent: "Urgent",
	calTasksLabel: "Tasks:",
	calTicketsLabel: "Tickets:",
	calToday: "Today",
	calUserFallback: "User",
	calWeek: "Week",
	calculatePayroll: "Calculate Payroll",
	calculated: "Calculated",
	calculations: "Calculations",
	calendarEventType: "Calendar event",
	calling: "Calling",
	cancel: "Cancel",
	clearText: "Clear text",
	cancelAction: "Cancel Action",
	cancelBack: "Cancel back",
	cancelled: "Cancelled",
	cannotBeUndone: "This action cannot be undone.",
	cannotPayOnline: "Cannot pay online",
	cart: "Employees",
	categories: "Categories",
	category: "Category",
	categoryPerformance: "Category Performance",
	certificate: "Certificate",
	certificateImages: "Certificate Images",
	certificates: "Certificates",
	changedDate: "Change Date",
	channel: "Channel",
	channelWritePermissionDescription: "Only chat admins can write messages",
	channels: "Channels",
	charts: "Charts",
	chat: "Chat",
	chatActions: "chat actions",
	chatActiveLabel: "active...",
	chatAddOption: "Add option",
	chatAddUsers: "Add users",
	chatAddedToGroupNotification: "Added to group chat",
	chatAddedYouToGroup: "added you to",
	chatAudioCall: "audio call",
	chatBulkDeleteFailed: "Bulk delete failed.",
	chatBulkForwardFailed: "Bulk forward failed.",
	chatCallMessage: "Call message",
	chatChoosingEmoji: "choosing emoji...",
	chatClickMapToChoosePoint: "Click on the map to choose a custom point.",
	chatCoordinatesUnavailable: "Coordinates unavailable",
	chatCopyCoordinates: "Copy coordinates",
	chatCopyCoordinatesFailed: "Failed to copy coordinates.",
	chatCreatePoll: "Create poll",
	chatCurrent: "Current",
	chatCurrentLocation: "Current location",
	chatDashboard: "Chat Dashboard",
	chatDeleteFailed: "Delete failed",
	chatDeleteForMe: "Delete chat",
	chatDeleteForMeConfirm:
		"Delete this chat only for you? Your visible history will be cleared and the chat will disappear from your sidebar.",
	chatDeleteForMeOnly: "Delete for me only",
	chatDeleteForParticipants: "Delete for participants too",
	chatDeleteLocation: "Delete location",
	chatDeleteSelectedMessagesDescription:
		"This action removes selected messages from your chat view. Messages that cannot be deleted with your current permissions will be reported as failed.",
	chatDeleteSelectedMessagesTitle: "Delete selected messages",
	chatDeletionPartialWarning:
		"Deletion results may be partial if some messages are already deleted or permission checks fail.",
	chatDepartmentSaveFailed: "Department update failed",
	chatDepartmentSaveFailedTryAgain: "Please try updating the department again.",
	chatDeselectAllMessages: "Deselect all",
	chatDestinationChatsLabel: "Destination chats",
	chatDestinationChatsPlaceholder: "Select one or more chats",
	chatDirect: "Chat Direct",
	chatDirectChat: "Direct chat",
	chatBlockUser: "Block user",
	chatBlockedContacts: "Blocked contacts",
	chatClearHistory: "Clear history",
	chatClearHistoryConfirm: "Clear this chat history only for you?",
	chatEditFailed: "Could not edit message",
	chatEditFailedTryAgain: "Please try editing again.",
	chatEditMessagePlaceholder: "Edit message...",
	writeMessage: "Type a message...",
	chatEditingMessage: "Editing message",
	chatExitSelectionMode: "Exit selection mode",
	chatMuteNotifications: "Mute notifications",
	chatMuteFor8Hours: "For 8 hours",
	chatMuteFor1Day: "For 1 day",
	chatMuteFor1Week: "For 1 week",
	chatMuteForever: "Forever",
	chatPinChat: "Pin chat",
	chatArchiveChat: "Archive chat",
	chatUnarchiveChat: "Unarchive chat",
	chatArchivedSection: "Archived",
	chatPinnedSection: "Pinned",
	chatAllSection: "All",
	chatMarkUnread: "Mark as unread",
	chatMarkRead: "Mark as read",
	chatBadgeDirect: "Direct",
	chatBadgeGroup: "Group",
	chatBadgeChannel: "Channel",
	chatUnblockUser: "Unblock user",
	chatUnmuteNotifications: "Unmute notifications",
	chatUnpinChat: "Unpin chat",
	chatUsers: "Users",
	chatExpired: "Expired",
	chatForwardFailed: "Forward failed",
	chatForwardSelectedMessagesTitle: "Forward selected messages",
	chatForwardableLabel: "forwardable",
	chatGeolocationUnavailable: "Geolocation is not available in this browser.",
	chatGroupChat: "group chat",
	chatGroupInfo: "Group info",
	chatGroupMembers: "Group members",
	chatGroupSettings: "Group settings",
	chatGroupSettingsDescription: "Set group image and linked HR department",
	chatID: "Chat ID",
	chatImageUploadFailed: "Image upload failed",
	chatImageUploadFailedTryAgain: "Please try uploading a different image.",
	chatIncludeLabel: "Include",
	chatIsChoosingEmoji: "is choosing emoji...",
	chatIsTyping: "is typing...",
	chatLastUpdated: "Last updated",
	chatLatitude: "Latitude",
	chatLive: "Live",
	chatLiveFor: "Live for",
	chatLiveLocation: "Live location",
	chatLiveLocationOptInWarning: "Live location is explicit opt-in and can be stopped anytime.",
	chatLiveLocationSharingActive: "Live location sharing is active",
	chatLoadingLocation: "Loading location...",
	chatLoadingPoll: "Loading poll...",
	chatLongitude: "Longitude",
	chatMessagesCannotBeForwarded: "message(s) cannot be forwarded and will be skipped.",
	chatMessagesDeleted: "Messages deleted",
	chatMessagesForwarded: "Messages forwarded",
	chatMoreActions: "More actions",
	chatNoAvailableUsersToAdd: "All available users are already in this group.",
	chatNoBackground: "No wallpaper",
	chatNoChatsFound: "No chats found",
	chatNoMessagesForwarded: "No messages could be forwarded.",
	chatNoSelectedMessagesDeleted: "No selected messages could be deleted.",
	chatOpenDepartmentPage: "Open department page",
	chatOpenMap: "Open map",
	chatOptionalAddressLabel: "Optional address label",
	chatOwnMessagesLabel: "own",
	chatPartialDelete: "Partial delete",
	chatPartialForward: "Partial forward",
	chatPattern: "Pattern",
	chatPickOnMap: "Pick on map",
	chatPickPointOnMap: "Pick a point on the map.",
	chatPinnedLocation: "Pinned location",
	chatPollAddAnotherOption: "Add another option",
	chatPollAddOptionFailed: "Failed to add option.",
	chatPollAllowAddingOptions: "Allow adding options",
	chatPollAllowMultipleAnswers: "Allow multiple answers",
	chatPollAllowRevote: "Allow revote",
	chatPollAnonymous: "Anonymous poll",
	chatPollAnonymousCannotAddOptions: "Anonymous quiz cannot allow adding options.",
	chatPollAtLeastOptions: "At least options required:",
	chatPollAutoClose: "Auto-close",
	chatPollChangeVote: "Change vote",
	chatPollChooseCorrectAnswer: "Choose at least one correct answer for quiz.",
	chatPollCloseDate: "Close date",
	chatPollCloseDateOrOpenPeriod: "Use either close date or open period, not both.",
	chatPollCloseFailed: "Failed to close poll.",
	chatPollClosePoll: "Close poll",
	chatPollCorrectAnswer: "Correct answer",
	chatPollCorrectAnswers: "Correct answers",
	chatPollCreateFailed: "Failed to create poll.",
	chatPollDeletePoll: "Delete poll",
	chatPollDescriptionMax: "Description must be at most",
	chatPollExplanationMax: "Explanation must be at most",
	chatPollHideResultsUntilClosed: "Hide results until closed",
	chatPollIncorrectAnswer: "Incorrect answer",
	chatPollLeaveEmptyKeepOpen: "Leave empty to keep poll open",
	chatPollLeaveEmptyNoTimer: "Leave empty for no timer",
	chatPollLoadVotersFailed: "Failed to load voters.",
	chatPollMultipleChoice: "Multiple choice",
	chatPollNewOption: "New option",
	chatPollNoVoteYet: "No vote yet",
	chatPollNoVotersForOption: "No voters found for this option.",
	chatPollOpenPeriod: "Open period",
	chatPollOptionMax: "Option must be at most",
	chatPollOptionRequired: "Option is required.",
	chatPollOptionsUnique: "Options must be unique.",
	chatPollPublic: "Public",
	chatPollQuestionMax: "Question must be at most",
	chatPollQuestionRequired: "Question is required.",
	chatPollQuiz: "Quiz",
	chatPollQuizExplanation: "Quiz explanation",
	chatPollRegular: "Regular",
	chatPollResultsHiddenUntilClosed: "Results are hidden until the poll is closed.",
	chatPollSearchVoters: "Search voters",
	chatPollShuffleOptions: "Shuffle options",
	chatPollSingleChoice: "Single choice",
	chatPollSingleChoiceOneCorrect: "Single-choice quiz can have only one correct answer.",
	chatPollSubmitVoteFailed: "Failed to submit your vote.",
	chatPollViewVoters: "View voters",
	chatPollVoteRecorded: "Vote recorded",
	chatPollVotersLabel: "voters",
	chatPollVotersTitle: "Poll voters",
	chatPollYouVoted: "You voted.",
	chatPollYouVotedCanChange: "You voted and can change your answer.",
	chatPreviewChronological: "Preview (chronological)",
	chatProvider: "Provider",
	chatReadCurrentLocationFailed: "Failed to read your current location.",
	chatRefreshCurrentLocation: "Refresh current location",
	chatRuleAllow: "Yes",
	chatRuleDeny: "No",
	chatRuleTimed: "Yes, for a limited time",
	chatRuleTimerDescription:
		"Example: set 1 to allow the action only during the first minute after sending.",
	chatRuleTimerMinutes: "Timer in minutes",
	chatSearchMessage: "Search message",
	chatSelectAllMessages: "Select all",
	chatSelectDepartment: "Select HR department",
	chatSelectOrLoadLocationFirst: "Select or load a location first.",
	chatSelectRepeatingBackground: "Select a repeating wallpaper",
	chatSelectUsersToAdd: "Select users to add",
	chatSelectedLabel: "selected",
	chatSelectionMode: "Selection mode",
	chatSendCurrentLocation: "Send current location",
	chatSendLocationFailed: "Failed to send location.",
	chatSendPinnedLocation: "Send pinned location",
	chatSendVenue: "Send venue",
	chatSentAt: "Sent",
	chatSettings: "Chat settings",
	chatSettingsEditRule: "Edit Messages",
	chatSettingsEditRuleDescription:
		"Choose whether sent messages can be edited always, never, or only for a limited time.",
	chatSettingsForwardRule: "Forward Messages",
	chatSettingsForwardRuleDescription:
		"Allow forwarding always, never, or only within a limited time after the original message was sent.",
	chatSettingsGlobalPageSubtitle:
		"Set personal chat rules here once. Only group admins can set rules for their groups.",
	chatSettingsGlobalPageTitle: "Global Chat Settings",
	chatSettingsGlobalRulesDescription:
		"These rules apply to all personal chats.",
	chatSettingsGlobalSavedSuccess: "Global chat settings updated successfully",
	chatSettingsCompactMode: "Compact mode",
	chatSettingsCompactModeDescription:
		"Reduce spacing and avatar size so more chats fit in the sidebar.",
	chatSettingsSidebarDescription: "Control how chats are displayed in the left sidebar.",
	chatSettingsSidebarTitle: "Chat Sidebar",
	chatSettingsShowLastMessage: "Show last message",
	chatSettingsShowLastMessageDescription:
		"Display the latest message preview and its date or time in the chat sidebar.",
	chatSettingsReplyRule: "Reply to Messages",
	chatSettingsReplyRuleDescription:
		"Control whether members can reply forever, never, or only during a time window after a message is sent.",
	chatSettingsResetToGlobal: "Restore group defaults",
	chatSettingsRulesAdminOnly: "Only chat admins can change these rules.",
	chatSettingsRulesDescription:
		"Choose whether members can forward, reply, or edit messages, and optionally limit those actions by time.",
	chatSettingsRulesTitle: "Chat Rules",
	chatSettingsSaveFailed: "Could not save chat settings",
	chatSettingsSaveFailedTryAgain: "Please try again.",
	chatSettingsUsingCustomRules: "This group uses rules set by its admins.",
	chatSettingsUsingGlobalRules: "This group uses default rules.",
	chatShareLocation: "Share location",
	chatSkipLabel: "Skip",
	chatSkippedLabel: "skipped",
	chatStartCall: "Start call",
	chatStartLiveSharing: "Start live sharing",
	chatStopLiveSharing: "Stop live sharing",
	chatType: "Chat Type",
	chatTypeToSearch: "Type to search",
	chatTyping: "typing...",
	chatUnnamedChat: "Unnamed chat",
	chatUpdatingSharedLocationFor: "Updating this shared location for",
	chatUploadGroupImage: "Upload group image",
	chatUserInfo: "User Info",
	chatUsersSaveFailed: "Failed to add users",
	chatUsersSaveFailedTryAgain: "Please try adding the selected users again.",
	chatVenue: "Venue",
	chatVenueTitle: "Venue title",
	chatVideoCall: "video call",
	chatViewReportedMessages: "View reported messages",
	chatWaitingDeviceCoordinates: "Waiting for device coordinates...",
	childcarePayment: "Childcare Payment",
	chooseBoard: "Choose a board to view its categories and tasks",
	cities: "Cities",
	city: "City",
	clear: "Clear",
	clearFilters: "Clear filters",
	clickTheButtonBelowToTakeTheNextStepOnYourJourney:
		"Click the button below to take the next step on your journey",
	contact: "Contact",
	contactEngagement: "Contact Engagement",
	contactGroup: "Contact Group",
	contactGroups: "Contact Groups",
	contactPlaylist: "Contact playlist",
	contactProfile: "Contact profile",
	contacts: "contacts",
	contactsByGender: "Clients by Gender",
	contactsByGroup: "Clients by Group",
	contactsUsing: "contacts using",
	contactsWithCarts: "Clients with Carts",
	contactsWithFavorites: "Clients with Favorites",
	clockInOut: "Clock In / Out",
	close: "Close",
	closeNavigation: "Close navigation",
	closeTicket: "Close Ticket",
	closed: "Closed",
	closed_late: "Closed after due date",
	closedDate: "Closed Date",
	closedTickets: "Closed Tickets",
	cmDashboard: "CM Dashboard",
	code: "Code",
	coin: "Coin",
	coinBurnTime: "Coin burn time",
	coinCount: "Coin count",
	color: "Color",
	comment: "Comment",
	comments: "Comments",
	addComment: "Add comment",
	postComment: "Post comment",
	explanation: "Explanation / Comment",
	commentTicket: "Comment Ticket",
	commissions: "Commissions",
	communicationPreferences: "Communication Preferences",
	community: "Community",
	company: "Company",
	completed: "Completed",
	completedDate: "Completed Date",
	completedTasks: "Completed tasks",
	completionRate: "completion rate",
	confirm: "Confirm",
	confirmAction: "Confirm Action",
	contactForm: "Contact form",
	contactForms: "Contact Forms",
	contactType: "Contact type",
	contacts: "Contacts",
	contentByType: "Content by Type",
	contentItems: "Content Items",
	contentManagementOverview: "Overview of content management system",
	contentOverTime: "Content Created Over Time (Last 30 Days)",
	continue: "Continue",
	contract: "Contract",
	contractEndDate: "Contract End Date",
	contractStartDate: "Contract Start Date",
	contractor: "Contractor",
	copy: "Copy",
	costOfBuildingPart: "Cost of building part",
	costOfBuildingPermit: "Cost of building permit",
	country: "Country",
	cpu: "CPU",
	create: "Order",
	board: "Board",
	kanban: "Kanban",
	boardAdmin: "Board admins",
	columnResponsible: "Column responsible",
	createBoard: "Create a new board",
	createChat: "Create Chat",
	createGroupChat: "Create Group Chat",
	createGroupSubmit: "Create",
	addNewCategory: "Add New Category",
	createNewCategory: "Create a new category",
	created: "Created",
	createdAt: "Created at",
	createdBy: "Created by",
	createdByUser: "Created By User",
	critical: "Critical",
	crmDashboard: "CRM Dashboard",
	cta1: "Call to action section 1",
	cta2: "Call to action section 2",
	cta3: "Call to action section 3",
	currency: "Currency",
	currentMonth: "Current Month",
	currentWeek: "Current Week",
	currentlyStreaming: "currently streaming",
	currentlyWorking: "Currently working",
	custom: "Custom",
	customerAcquisition: "Customer Acquisition",
	customerBaseOverview: "Customer Base Overview",
	customerInsights: "Customer Insights",
	customerRelationshipOverview: "Overview of customer relationship management",
	dashboard: "Dashboard",
	dashboardSubtitle: "Dashboard Subtitle",
	database: "Database",
	date: "Date",
	dateOfBirth: "Date Of Birth",
	dates: "Dates",
	datingAttendance: "Dating Attendance",
	dayOff: "Day off",
	meeting: "Meeting",
	dayOffForAllEmployees: "Day off for all employees",
	dayOffRemoved: "Day off removed",
	dayOffSavedForAllEmployees: "Day off saved for all employees",
	dayStatus: "Day Status",
	days: "days",
	daysLeft: "days left",
	daysOfWeek: "Days of week",
	daysWorked: "Days Worked",
	deadLine: "Dead Line",
	deadline: "Deadline",
	debt: "Debt",
	decline: "Decline",
	deductions: "Deductions",
	defaultEnergyMax: "Default energy max",
	defaultEnergyMin: "Default min energy",
	defaultStream: "Default Stream",
	defaultStreams: "Default Streams",
	defaultStreamsDesc: "default streams",
	delays: "Delays",
	delete: "Delete",
	deleteForEveryone: "Delete for everyone",
	deletePermanently: "Delete Permanently",
	deleteRule: "Delete rule",
	deleteSelected: "Delete selected",
	deleted: "Deleted",
	delivery: "Delivery",
	deliveryAddress: "Delivery Address",
	deliveryMethod: "Delivery method",
	density: "Density",
	department: "Department",
	departmentChatsHelp:
		"Link group and channel chats to this department. This stays in sync with each chat’s department field.",
	departmentLinkedChats: "Department chats",
	departments: "Departments",
	desc: "Description",
	description: "Description",
	depreciation: "Depreciation",
	designer: "Designer",
	detailedFilters: "Detailed filters",
	detailedSteps: "Detailed Steps",
	details: "Details",
	developed: "Developed",
	developedBy: "Developed by",
	deviceStatus: "Device status",
	difference: "Difference",
	diplomaImages: "Diploma images",
	directMessages: "Direct Messages",
	disableSteps: "Disable steps",
	disabledSteps: "Disabled steps",
	disk: "Disk",
	distributionByPaymentType: "Distribution by Payment Type",
	domainFacility: "Facility",
	domainFinance: "Finance",
	domainHR: "HR",
	domainIT: "IT",
	domainKey: "Domain key",
	domainOther: "Other",
	domainSecurity: "Security",
	done: "Done",
	download: "Download",
	downloadAsContact: "Download as contact",
	draft: "Draft",
	dragToReorder: "Drag to reorder",
	dropFilesHere: "Drop files here",
	dropFilesHereOrClick: "Drop files here or click to add more",
	dropzoneText: "Drag images here or click to select files",
	dueDate: "Due Date",
	duration: "Duration",
	ecommerceDashboard: "Ecommerce Dashboard",
	edit: "Edit",
	editComment: "Edit comment",
	editItem: "Edit Item",
	editProject: "Edit project",
	editRule: "Edit rule",
	edited: "Edited",
	editingRule: "Editing rule",
	email: "Email",
	sendEmail: "Send email",
	employee: "Employee",
	employees: "employees",
	employeesPerDepartment: "Employees per department",
	employeesWithOT: "Employees with OT",
	employerExpenses: "Employer Expenses",
	employmentStatus: "Employment Status",
	emptyTrash: "Empty Trash",
	end: "End",
	endDate: "End Date",
	endDateMustBeLaterThanStartDate: "End date must be later than start date",
	endDateShort: "End Date",
	endOfTraining: "End of Training",
	endTime: "End time",
	ends: "Ends",
	energyLevel: "Energy level",
	energyScheduling: "Energy scheduling",
	enterAmount: "Enter amount",
	enterFeatureSuffix: "Enter feature suffix",
	enterFeatureText: "Enter feature text",
	enterGroupName: "Enter group name...",
	enterLabel: "Enter label",
	enterPersons: "Enter persons",
	enterRuleName: "Enter rule name",
	entityTypeLabel: "Entity type",
	entry: "Entry",
	error: "Error",
	errorMessage: "An error occurred, please try again.",
	errorOccurred: "An error occurred",
	errorPageButton: "Take me home",
	errorPageHelpText: "Need help? Contact our support team",
	errorPageSecondaryButton: "Report this issue",
	errorPageSubtitle: "The page you're looking for doesn't exist",
	errorPageText:
		"Don't worry, it happens to the best of us! The page might have been moved, deleted, or you might have entered the wrong URL. Let's get you back on track.",
	errorPageTitle: "Oops! Something went wrong",
	errorUserNotFound: "User not found",
	estOTPay: "Est. OT Pay",
	estimatedHours: "Estimated Hours",
	eventType: "Event type",
	exit: "Exit",
	expectedSalary: "Expected Salary",
	expireDate: "Expire Date",
	expired: "Expired",
	expiresOn: "Expires on",
	expiringIdCards: "Expiring ID Cards",
	expiringPassports: "Expiring Passports",
	export: "Export",
	exportData: "Export Data",
	exportToExcel: "Export to Excel",
	extraLarge: "Extra Large",
	extraSmall: "Extra Small",
	faqQuestions: "FAQ Questions",
	favorites: "Favorites",
	features: "Features",
	female: "Female",
	fields: "Fields",
	file: "File",
	fileHasBeenRemoved: "File has been removed",
	fileMovedToTrash: "File moved to trash",
	fileRestored: "File restored",
	fileWillBeMovedToTrash: "File will be moved to trash",
	files: "Files",
	filesRestored: "Files restored",
	filesWillBePermanentlyDeleted: "files will be permanently deleted.",
	filter: "Filter",
	filterBy: "Filter by",
	filters: "Filters",
	finish: "Finish",
	fired: "Fired",
	firstIn: "First in",
	firstName: "First Name",
	forgotPassword: "Forgot Password?",
	forward: "Forward",
	forwardMessage: "Forward message",
	forwarded: "Forwarded",
	forwardedFrom: "Forwarded from",
	fri: "Friday",
	from: "From",
	fromAttendanceLogs: "Filled from attendance logs for this employee and period; you can adjust.",
	fromDb: "From database",
	fromHrSettings: "HR settings",
	gallery: "Gallery",
	gender: "Gender",
	genderDistribution: "Gender Distribution",
	globalFilter: "Global filter",
	globalSearchClose: "Close",
	globalSearchCmd_goCalendar_desc: "Calendar events",
	handoverDocument: "Handover document",
	globalSearchCmd_goCalendar_label: "Go to Calendar",
	globalSearchCmd_goChat_desc: "Open messaging",
	globalSearchCmd_goChat_label: "Go to Chat",
	globalSearchCmd_goCrm_desc: "Client management",
	globalSearchCmd_goCrm_label: "Go to CRM",
	globalSearchCmd_goFinance_desc: "Finance module",
	globalSearchCmd_goFinance_label: "Go to Finance",
	globalSearchCmd_goHr_desc: "Human Resources module",
	globalSearchCmd_goHr_label: "Go to HR",
	globalSearchCmd_goIt_desc: "IT equipment",
	globalSearchCmd_goIt_label: "Go to IT",
	globalSearchCmd_goProjects_desc: "Projects database",
	globalSearchCmd_goProjects_label: "Go to Projects",
	globalSearchCmd_goRadio_desc: "Music & playlists",
	globalSearchCmd_goRadio_label: "Go to Radio",
	globalSearchCmd_goTickets_desc: "Support ticket system",
	globalSearchCmd_goTickets_label: "Go to Tickets",
	globalSearchCmd_goTodo_desc: "Todo boards & tasks",
	globalSearchCmd_goTodo_label: "Go to Todo",
	globalSearchCmd_messageUser_desc: "Open chat to send message",
	globalSearchCmd_messageUser_label: "Message User",
	globalSearchCmd_newContact_desc: "Add a CRM contact",
	globalSearchCmd_newClient_label: "New Client",
	globalSearchCmd_newOrder_desc: "Create an order",
	globalSearchCmd_newOrder_label: "New Order",
	globalSearchCmd_newProject_desc: "Create a project",
	globalSearchCmd_newProject_label: "New Project",
	globalSearchCmd_newTask_desc: "Create a todo task",
	globalSearchCmd_newTask_label: "New Task",
	globalSearchCmd_newTicket_desc: "Create a support ticket",
	globalSearchCmd_newTicket_label: "New Ticket",
	globalSearchCommandBadge: "Command",
	globalSearchCommands: "Commands",
	globalSearchCopied: "Copied!",
	globalSearchCopyLink: "Copy link",
	globalSearchDirectMessage: "Direct Message",
	globalSearchFilterAll: "All",
	globalSearchFilterCalendar: "Calendar",
	globalSearchFilterChats: "Chats",
	globalSearchFilterDevices: "Devices",
	globalSearchFilterEcom: "Ecommerce",
	globalSearchFilterFinance: "Finance",
	globalSearchFilterPeople: "People",
	globalSearchFilterProjects: "Projects",
	globalSearchFilterRadio: "Radio",
	globalSearchFilterTickets: "Tickets",
	globalSearchFilterTodo: "Todo",
	globalSearchHidePreview: "Hide preview",
	globalSearchNavigate: "Navigate",
	globalSearchOpen: "Open",
	globalSearchOpenInNewTab: "Open in new tab",
	globalSearchPageBadge: "Page",
	globalSearchPlaceholder: "Search anything in APIT (users, tickets, chats, devices…)",
	globalSearchPreviewAddress: "Address",
	globalSearchPreviewArtist: "Artist",
	globalSearchPreviewChat: "Chat",
	globalSearchPreviewCompany: "Company",
	globalSearchPreviewCreated: "Created",
	globalSearchPreviewDeviceId: "Device ID",
	globalSearchPreviewEmail: "Email",
	globalSearchPreviewEmployeeNumber: "Employee #",
	globalSearchPreviewEnd: "End",
	globalSearchPreviewInfo: "Info",
	globalSearchPreviewIp: "IP",
	globalSearchPreviewLocation: "Location",
	globalSearchPreviewMac: "MAC",
	globalSearchPreviewNumber: "Number",
	globalSearchPreviewOrderNumber: "Order №",
	globalSearchPreviewPhone: "Phone",
	globalSearchPreviewSent: "Sent",
	globalSearchPreviewStart: "Start",
	globalSearchPreviewUsername: "Username",
	globalSearchPreviewVendor: "Vendor",
	globalSearchPreviewVersion: "Version",
	globalSearchRecentSearches: "Recent Searches",
	globalSearchRecentlyOpened: "Recently Opened",
	globalSearchSectionArtists: "Artists",
	globalSearchSectionAttendanceDevices: "Attendance Devices",
	globalSearchSectionBrands: "Brands",
	globalSearchSectionCalendarEvents: "Calendar Events",
	globalSearchSectionCameras: "Cameras",
	globalSearchSectionChats: "Chats",
	globalSearchSectionClientGroups: "Client Groups",
	globalSearchSectionClients: "Clients",
	globalSearchSectionCpus: "CPUs",
	globalSearchSectionDepartments: "Departments",
	globalSearchSectionEcomCategories: "Categories",
	globalSearchSectionFinanceCardIssuers: "Card Issuers",
	globalSearchSectionFinanceCards: "Cards",
	globalSearchSectionFinanceCategories: "Finance Categories",
	globalSearchSectionFinanceTransactions: "Transactions",
	globalSearchSectionGpus: "GPUs",
	globalSearchSectionKeyboards: "Keyboards",
	globalSearchSectionLaptops: "Laptops",
	globalSearchSectionMessages: "Messages",
	globalSearchSectionMice: "Mice",
	globalSearchSectionMonitors: "Monitors",
	globalSearchSectionOrders: "Orders",
	globalSearchSectionPcs: "PCs",
	globalSearchSectionPlaylists: "Playlists",
	globalSearchSectionPositions: "Positions",
	globalSearchSectionPrinters: "Printers",
	globalSearchSectionProblems: "Problems",
	globalSearchSectionProducts: "Products",
	globalSearchSectionProjects: "Projects",
	globalSearchSectionRams: "RAM",
	globalSearchSectionRoms: "Storage",
	globalSearchSectionRooms: "Rooms",
	globalSearchSectionRouters: "Routers",
	globalSearchSectionSmbs: "SMB",
	globalSearchSectionSoftware: "Software",
	globalSearchSectionSwitches: "Switches",
	globalSearchSectionTelephones: "Telephones",
	globalSearchSectionTickets: "Tickets",
	globalSearchSectionTodoBoards: "Boards",
	globalSearchSectionTodoCategories: "Categories",
	globalSearchSectionTodoTasks: "Tasks",
	globalSearchSectionTracks: "Tracks",
	globalSearchSectionUsers: "People",
	globalSearchSectionWarrantyProviders: "Warranty Providers",
	globalSearchSelectPreview: "Select an item to preview",
	globalSearchShortcutHint: "Ctrl + K",
	globalSearchShowPreview: "Show preview",
	globalSearchSubtitle: "Search across all modules",
	globalSearchSuggest1: "Search tickets assigned to me",
	globalSearchSuggest2: "Find employee by email",
	globalSearchSuggest3: "Search chat messages",
	globalSearchSuggest4: "Find device by IP",
	globalSearchSuggest5: "Search contact by phone",
	globalSearchSuggest6: "Go to projects",
	globalSearchTrySearchingFor: "Try searching for",
	goBack: "Go Back",
	goToMessage: "Go to message",
	goToUserAttendanceTab: "Go to user page",
	goToUserAttendanceTabTooltip: "Open this employee in HR Users on the Attendance tab",
	gpu: "GPU",
	grossSalary: "Gross Salary",
	group: "Group",
	groupChat: "Group Chat",
	groupChatWritePermissionDescription: "Everyone in the chat can write messages",
	groupChats: "Group Chats",
	groupName: "Group Name (Optional)",
	healthInsurance: "Health Insurance",
	healthInsuranceBenefit: "Health Insurance (benefit)",
	help: "Help",
	hideAllSteps: "Hide all steps",
	hideHistory: "Hide history",
	hideProjectDetails: "Hide project details",
	hideTableColumnFilters: "Hide column filters",
	hideTimeline: "Hide timeline",
	high: "High",
	highestSpendingCustomers: "Highest Spending Customers",
	highlight: "Highlight",
	highlightFeature: "Highlight feature",
	history: "History",
	historyTable: "History table",
	holiday: "Holiday",
	holidayNonWorking: "Holiday / non-working day",
	hourlyRate: "Hourly Rate",
	hourlyRateBaseLinked:
		"Updates base salary from hourly rate × regular hours (when regular hours > 0).",
	hr2025RateReferenceTables: "2025 Rate Reference Tables",
	hrAccrualAnnualTotal: "Annual total: {amount} days",
	hrAccrualDaily: "Daily (÷ 365)",
	hrAccrualEachDay: "Each day: +{amount} vacation days",
	hrAccrualEachMonthFirst: "Each 1st of month: +{amount} vacation days",
	hrAccrualMethod: "Accrual Method",
	hrAccrualMethodDesc: "How vacation accumulates",
	hrAccrualMonthly: "Monthly (÷ 12, on 1st)",
	hrAccrualMonthlyEquivalent: "Monthly equivalent: ~{amount} days",
	hrAccrualPreview: "Accrual Preview",
	hrArmeniaIncomeTaxCalculator: "Armenia Income Tax Calculator",
	hrArmeniaTaxRates: "Armenia Tax Rates",
	hrCalcSummaryGrossToNet:
		"For a registered salary of {gross} AMD, you will receive {net} AMD in hand after deducting {deductions} AMD in taxes and contributions.",
	hrCalcSummaryNetToGross:
		"To receive {net} AMD in hand, your employment contract must show a gross salary of {gross} AMD.",
	hrCalculationBreakdown: "Calculation breakdown",
	hrCalculationDirection: "Calculation direction",
	hrDefaultBenefitsDescription:
		"These defaults are applied to all payroll calculations unless overridden per-employee.",
	hrDefaultMonthlyBenefits: "Default Monthly Benefits (AMD)",
	hrDesiredNetSalaryLabel: "Desired net salary (take-home amount)",
	hrEmployeePensionLabel: "Employee Pension:",
	hrEmployeePensionRate: "Employee Pension Rate",
	hrEmployeePensionRateDesc: "Mandatory for born after 1973 (2.5%)",
	hrEmployerPensionRate: "Employer Pension Rate",
	hrEmployerPensionRateDesc: "Employer pension contribution (2.5%)",
	hrFailedToSaveSettings: "Failed to save settings",
	hrGrossSalaryAMD: "Gross Salary (AMD)",
	hrGrossSalaryDescription: "Enter the amount listed on your employment contract",
	hrGrossSalaryLabel: "Gross salary (registered / contract amount)",
	hrGrossSalaryRegistered: "Gross Salary (registered)",
	hrGrossToNet: "Gross → Net",
	hrHealthInsuranceAges: "Health Insurance (ages 18–65)",
	hrHealthInsuranceBenefit: "Health Insurance",
	hrHealthInsuranceBenefitDesc: "Monthly employer health insurance contribution (AMD)",
	hrHealthInsuranceEmployeeColumn: "Employee",
	hrHealthInsuranceEmployeeShare: "Health Insurance (employee share)",
	hrHealthInsuranceStateColumn: "State",
	hrITSector: "IT sector (10% income tax)",
	hrITSectorDesc: "Licensed IT company employee",
	hrIncomeTax: "Income Tax",
	hrIncomeTaxLabel: "Income Tax:",
	hrIncomeTaxRate: "Income Tax Rate",
	hrIncomeTaxRateDesc: "Flat 20% in Armenia since 2020",
	hrLeaveAccrualConfiguration: "Leave Accrual Configuration",
	hrLiveRates: "Live rates",
	hrLunchCoverage: "Lunch Coverage",
	hrLunchCoverageDesc: "Monthly lunch/food allowance (AMD)",
	hrMandatoryHealthInsurance: "Mandatory health insurance (18–65)",
	hrMandatoryHealthInsuranceDesc: "Include 2025 health insurance tiers",
	hrMilitaryStampRate: "Military Stamp Rate",
	hrMilitaryStampRateDesc: "Leave 0 if not applicable",
	hrMonthlyFee: "Monthly Fee",
	hrNetSalaryDescription: "Enter how much you want to receive in hand",
	hrNetSalaryLabel: "Net Salary:",
	hrNetSalaryTakeHome: "Net Salary (take-home)",
	hrNetToGross: "Net → Gross",
	hrOvertimeRateMultiplier: "Overtime Rate Multiplier",
	hrOvertimeRateMultiplierDesc: "e.g. 1.5× means 50% overtime premium",
	hrOvertimeRules: "Overtime Rules",
	hrBreakIntervals: "Break Intervals",
	hrBreakIntervalsDesc:
		"Fixed daily time windows (e.g. lunch) excluded from working hours for everyone. You can add more than one.",
	hrBreakIntervalsEmpty: "No break intervals configured",
	hrBreakIntervalStart: "Break start",
	hrBreakIntervalEnd: "Break end",
	hrAddBreakInterval: "Add break",
	hrOvertimeThreshold: "Overtime Threshold (hours/day)",
	hrOvertimeThresholdDesc: "Hours worked above this trigger overtime rate",
	hrStatus: "HR Status",
	hrPensionMandatory: "Mandatory / Pre-07/2018 voluntary (5%)",
	hrPensionNone: "Non-participant (0%)",
	hrPensionPost2018: "Post-07/2018 voluntary (5%)",
	hrPensionSystem: "Pension system",
	hrPensionSystemDesc: "Your funded pension participation status",
	hrSettingsPageSubtitle: "Configure payroll, leave, and attendance rules",
	hrSettingsPageTitle: "HR Settings",
	hrSettingsUpdatedSuccessfully: "HR settings updated successfully",
	hrSickDaysPerYear: "Sick Days per Year",
	hrSickDaysPerYearDesc: "Paid sick leave days per calendar year",
	hrSocialPaymentPension: "Social Payment (pension)",
	hrSocialTaxRate: "Social Tax Rate",
	hrSocialTaxRateDesc: "Currently 0% in Armenia (replaced by pension)",
	hrStampFee: "Stamp Fee (Military Insurance Fund)",
	hrStampFeeTooltip: "Military Insurance Fund — tiered flat fee based on gross salary bracket",
	hrStandardWorkSchedule: "Standard Work Schedule",
	hrStateHealthContribution: "State health contribution",
	hrStateHealthContributionNote:
		"added by the state to your health insurance package (not deducted from your salary).",
	hrSuffixDays: "days",
	hrSuffixHours: "hrs",
	hrSuffixTimes: "×",
	hrSummary: "Summary",
	hrTabDefaultBenefits: "Default Benefits",
	hrTabLeaveAccrual: "Leave Accrual",
	hrTabTaxCalculator: "Tax Calculator",
	hrTabTaxesArmenia: "Taxes (Armenia)",
	hrTabWorkSchedule: "Work Schedule",
	hrTaxPreviewTitle: "Tax Preview (on 500,000 AMD gross)",
	hrTaxRatesDescription: "Rates are applied to gross salary. Enter as percentages (e.g. 20 = 20%).",
	hrTaxRatesDisclaimer:
		"Rates based on 2025–2026 Armenian legislation. Income tax: 20% standard, 10% for licensed IT companies. Pension: 5% (mandatory/pre-2018 voluntary) or 5% flat (post-2018 voluntary). The 10% excess rate on pension applies to mandatory/pre-2018 participants earning above 500,000 AMD. Always verify with a certified accountant for payroll processing.",
	hrThresholdWarning: "Threshold warning",
	hrThresholdWarningText:
		"Your salary is near a tier boundary (100k / 200k / 500k / 1M AMD). At these points the stamp fee and health insurance jump to a higher bracket, meaning a small gross increase can reduce net pay. The calculator always shows the minimum gross that yields the requested net.",
	hrTickets: "HR Tickets",
	hrTotalDeductions: "Total Deductions",
	hrTotalEmployeeDeductionsLabel: "Total Employee Deductions:",
	hrTransportAllowance: "Transport Allowance",
	hrTransportAllowanceDesc: "Monthly transport benefit (AMD)",
	hrVacationDaysPerYear: "Vacation Days per Year",
	hrVacationDaysPerYearDesc: "Full annual entitlement (Armenia minimum: 20)",
	hrWorkingDayEnd: "Working Day End",
	hrWorkingDayEndDesc: "Expected shift end. Daily hours are derived from start/end times",
	hrWorkingDayStart: "Working Day Start",
	hrWorkingDayStartDesc: "Expected clock-in time for attendance and lateness checks",
	hrAttendanceAutoCloseTime: "Automatic checkout time",
	hrAttendanceAutoCloseTimeDesc: "At this time, forgotten check-ins from the previous day are automatically checked out",
	hrWeekendDays: "Weekend Days",
	hrWeekendDaysDesc: "Select which days of the week are non-working weekends",
	hrAttendanceDeviceSync: "Attendance device sync",
	hrIgnoredAttendanceDevicePins: "Ignored device PINs",
	hrIgnoredAttendanceDevicePinsDesc:
		"Punches from these ZKTeco device PINs are skipped during sync. Their owners are excluded from global Attendance dashboards and statistics, but remain visible as Ignored on their user Attendance page.",
	hrIgnoredAttendanceDevicePinsInputDesc:
		"Type a device PIN and press Enter to add it. Saved as 5-digit codes (e.g. 1104 becomes 01104). Click × on a badge to remove.",
	hrIgnoredAttendanceDevicePinsPlaceholder: "Type PIN and press Enter",
	hrIgnoredAttendanceUsers: "Ignored users",
	hrIgnoredAttendanceUsersDesc: "These users stay visible in user lists and their own Attendance page, but are excluded from global Attendance dashboards and statistics.",
	hrIgnoredAttendanceUsersPlaceholder: "Select a user and press Enter",
	hrWorkingDaysPerWeek: "Working Days per Week",
	hrWorkingDaysPerWeekDesc: "Mon–Fri = 5, Mon–Sat = 6",
	hrWorkingHoursPerDay: "Working Hours per Day",
	hrWorkingHoursPerDayDesc: "Standard hours before overtime kicks in",
	href: "Href",
	humanResources: "Human Resources",
	id: "ID",
	idCard: "ID Card",
	idCardEndDate: "ID Card End Date",
	idCardNo: "ID Card No",
	idCardStartDate: "ID Card Start Date",
	idCart: "ID Cart",
	image: "Image",
	immediateSupervisor: "Immediate Supervisor",
	importance: "Importance",
	important: "Important",
	inProgress: "In Progress",
	inSelectedPeriod: "in selected period",
	inStock: "In Stock",
	in_progress: "In Progress",
	inactive: "Inactive",
	inactiveTime: "Inactive time",
	incident: "Incident",
	incomeTaxAmount: "Income Tax Amount",
	incomeTaxRate: "Income Tax Rate (%)",
	incomingCall: "Incoming call",
	incomingVideoCall: "Incoming video call",
	incorrectLogin: "You entered an incorrect username or password",
	index: "#",
	inputInArmenian: "Input in Armenian",
	inputInLatin: "Input in Latin",
	inputInNumbers: "Input in numbers",
	inputInRussian: "Input in Russian",
	inputNumber: "Input number",
	inputNumbers: "Input numbers",
	instagramPosts: "Instagram Posts",
	insufficientVacationBalance: "Insufficient vacation balance",
	interview1: "Interview",
	interview2: "Interview",
	interview3: "Training",
	interview4: "Internship",
	interviewDate: "Interview Date",
	interviewTime: "Interview Time",
	introSection: "Intro section",
	invalidDate: "Invalid delivery date",
	inventorySummary: "Inventory Summary",
	ip: "IP",
	ipAddress: "IP Address",
	isActive: "Active",
	isColor: "Is color",
	isPrivateOffice: "Is private office",
	isPublic: "Public",
	isSystem: "System",
	itHierarchyAddCatalogCpu: "Add CPU (catalog)",
	itHierarchyAddCatalogGpu: "Add GPU (catalog)",
	itHierarchyAddCatalogRam: "Add RAM (catalog)",
	itHierarchyAddCatalogRom: "Add storage (catalog)",
	itHierarchyAddMonitor: "Add monitor",
	itHierarchyAddLaptop: "Add laptop",
	itHierarchyAttachedPc: "Attached PC",
	itHierarchyAddPc: "Add PC",
	itHierarchyAddPrinter: "Add printer",
	itHierarchyAddRoom: "Add room",
	itHierarchyAddRouter: "Add router",
	itHierarchyAddSwitch: "Add switch",
	itHierarchyAddWarrantyProvider: "Add warranty provider",
	itHierarchyMonitorsOnPc: "Monitors on this PC",
	itHierarchyPcsInRoom: "PCs in this room",
	itHierarchyPcsUsingPart: "PCs using this part",
	itHierarchyLaptopsUsingPart: "Laptops using this part",
	itHierarchyPcsWithWarranty: "PCs with this warranty provider",
	itHierarchyPrintersOnPc: "Printers on this PC",
	itHierarchyRoutersInRoom: "Routers in this room",
	itHierarchySwitchesInRoom: "Switches in this room",
	itUsedInOtherPlaces: "Used in other places",
	itTickets: "IT Tickets",
	items: "items",
	justifiedAbsence: "Justified absence",
	keyText: "Key Text",
	keyboards: "Keyboards",
	label: "Label",
	language: "Language",
	languagePickerLabel: "Language",
	large: "Large",
	last7Days: "logged in last 7 days",
	lastAction: "Last action",
	lastLogin: "Last login",
	lastName: "Last Name",
	lastOut: "Last out",
	lastPunch: "Last punch",
	lasts: "Duration",
	late: "Late",
	lateDeparture: "Late departure",
	latestCustomerOrders: "Latest Customer Orders",
	leader: "Leader",
	attendanceManagersFilter: "Managers",
	attendanceLeadersFilter: "Leaders",
	leaveBalance: "Leave balance",
	userLeaveBalanceSubtitle:
		"Edit the current vacation days for {year}. Attendance and leave usage still update the used amount.",
	userLeaveBalanceSave: "Save vacation days",
	userLeaveBalanceVacationDays: "Vacation days",
	userLeaveBalanceBaselineHint:
		"This sets the user's current vacation baseline. Later attendance recalculations keep this value while still counting newly used vacation days.",
	userLeaveBalanceLoadFailed: "Leave balance load failed",
	userLeaveBalanceUpdatedTitle: "Vacation days updated",
	userLeaveBalanceUpdatedMessage: "The user's vacation balance was saved.",
	userLeaveBalanceUpdateFailedTitle: "Vacation update failed",
	legacyRelatedList: "Legacy single related list",
	linkCopied: "Link copied",
	list: "List",
	listeners: "Listeners",
	livingAddress: "Living address",
	loading: "Loading",
	loanDeductions: "Loan Deductions",
	localCode: "Local Code",
	logOut: "Log out",
	login: "Login",
	loginButton: "Log in",
	loginFailed: "Login failed",
	loginFailedMessage: "Please check your login credentials",
	loginSuccess: "Login success",
	loginSuccessMessage: "You have successfully logged in",
	loginToStartSession: "Sign in to start a session",
	logout: "Logout",
	low: "Low",
	lunchCoverage: "Lunch Coverage",
	mac: "MAC",
	macAddress: "MAC Address",
	main: "Main",
	mainInformation: "Basic information",
	mainInfo: "Main information",
	contactInfo: "Contact information",
	personalInfo: "Personal information",
	workingInfo: "Working information",
	probation: "Probation",
	educationInfo: "Education information",
	male: "Male",
	manualAdjustments: "Manual Adjustments",
	manualAttendanceEntry: "Manual entry",
	manualOptions: "Manual options",
	maps: "Maps",
	maritalStatus: "Marital status",
	markAllAsRead: "Mark all as read",
	markSelectedAsRead: "Mark selected as read",
	maternityLeave: "Maternity",
	maxEnergy: "Max energy",
	maxFilesReached: "Maximum files reached",
	maxSize: "Max size",
	mediaGallery: "Media Gallery",
	mediaGalleryDescription: "Media gallery description",
	mediator: "Mediator",
	medium: "Medium",
	members: "Members",
	menu: "Menu",
	message: "Message",
	messages: "Messages",
	messagesByType: "Messages By Type",
	messagesOverTime: "Messages Over Time (Last 30 Days)",
	militaryStampAmount: "Military Stamp Amount",
	militaryStampRate: "Military Stamp Rate",
	minimap: "Minimap",
	minEnergy: "Min energy",
	minute: "minute",
	minutes: "Minutes",
	missingInterval: "Missing interval",
	missing: "Missing",
	mon: "Monday",
	monitor: "Monitor",
	monitors: "Monitors",
	month: "Month",
	monthly: "Monthly",
	mood: "Mood",
	more: "Additional",
	moreDetailed: "More detailed",
	moreThan: "More than",
	motherProject: "Mother Project",
	mounted: "Mounted",
	mouses: "Mouses",
	moveToTrash: "Move to Trash",
	movedToTrash: "Moved to trash",
	myActiveSteps: "My active steps",
	myInvolvement: "My involvement",
	myProjects: "My Projects",
	myRole: "My role",
	mySteps: "My steps",
	myTickets: "My Tickets",
	na: "N/A",
	name: "Name",
	netCash: "Net Cash",
	netOfficial: "Net Official",
	netSalary: "Net Salary",
	newContacts: "New Contacts",
	newContactsOverTime: "New Contacts Over Time (Last 30 Days)",
	newMessage: "New message",
	newProducts: "New Products",
	newProject: "New Project",
	newProjects: "New Projects",
	newThisPeriod: "New This Period",
	newTicket: "New ticket",
	newTicketCreatedBy: "New ticket created by",
	newTracks: "New Tracks",
	newTracksOverTime: "New Tracks Over Time (Last 30 Days)",
	next: "Next",
	nextComposition: "Next composition",
	nextStep: "Next step",
	noAccess: "No access",
	noActiveSteps: "No active steps",
	noBoardsFound: "No boards found",
	noCategoriesFound: "No categories found",
	noCategoryDataAvailable: "No category data available",
	noContent: "There is no content",
	noCustomerDataAvailable: "No customer data available",
	noData: "No data available",
	noDataAvailable: "No data available",
	noDataAvailableForSelectedPeriod: "No data available for selected period",
	noDepartment: "No department",
	noDepartments: "No departments",
	noDescription: "No description",
	noEmail: "No Email",
	noExpiringIdCards: "No expiring ID cards",
	noExpiringPassports: "No expiring passports",
	noGroup: "No Group",
	noMediaDescription: "No media description",
	noMediaFound: "No media found",
	noMoreItems: "No more items",
	noName: "No name",
	noNeedStep45: "No Need Step 4-5",
	noNotifications: "No notifications",
	noOrdersInSelectedPeriod: "No orders in selected period",
	noOvertimeRecords: "No overtime records found",
	noPaymentDataAvailable: "No payment data available",
	noProjectsAssigned: "No projects assigned",
	noProjectsAssignedOrInvolved: "No projects assigned or involved",
	noRecentContacts: "No recent contacts",
	noRecentContent: "No recent content",
	noRecentTickets: "No recent tickets",
	noRecentTracks: "No recent tracks",
	noRecipientInformation: "No recipient information",
	noResponsible: "No responsible",
	noResult: "No results found",
	noResults: "No results found",
	noResultsFound: "No results found",
	noRulesAdded: "No rules added",
	noStatusData: "No status data available",
	noSystemDaysOffThisMonth: "No system-wide days off this month",
	noTaskDataAvailable: "No task data available",
	noTasksFound: "No tasks found.",
	noTasksYet: "No tasks yet",
	noTasksYetDescription: "No tasks yet",
	noUpcomingBirthdays: "No upcoming birthdays",
	noUsersFound: "No users found",
	noUsersInDepartment: "No users in this department",
	noWorkHourData: "No work hour data",
	no_priority: "No Priority",
	nonWorking: "Non-working day",
	none: "None",
	notAvailable: "Product not available",
	notAllowedToMoveTask: "You are not allowed to move this task",
	notCorrectLoginCredentials: "Not correct login credentials",
	notLoggedInToday: "Not logged in today",
	notPlaced: "Not placed",
	notPresent: "Not Present",
	notResponded: "Not Responded",
	notWorking: "Not working",
	deviceProblems: "Device problems",
	openTickets: "Open tickets",
	note: "Note",
	nothingFound: "Nothing found",
	notifications: "Notifications",
	notificationsBellAria: "Open notifications",
	similarTicketNotifications: "Similar ticket notifications",
	number: "Number",
	"office-map": "Office Map",
	officeMapActivatePlacement: "Activate Placement",
	officeMapAgent: "Agent",
	officeMapAll: "All",
	officeMapAttendanceDevice: "Attendance Device",
	officeMapAttendanceDevices: "Attendance",
	officeMapCable: "Cable",
	officeMapCableLinePlaced: "Cable line was placed",
	officeMapCableRemovedFromMap: "Cable removed from map",
	officeMapCables: "Cables",
	officeMapCamera: "Camera",
	officeMapCameras: "Cameras",
	officeMapNvr: "NVR",
	officeMapChat: "Chat",
	officeMapChatWasNotCreated: "Chat was not created",
	officeMapConnectToCamera: "Connect to Camera",
	officeMapCpu: "CPU",
	officeMapDeactivate: "Deactivate",
	officeMapDeviceDetails: "Device Details",
	officeMapDesk: "Desk",
	officeMapDesks: "Desks",
	officeMapDeviceId: "Device ID",
	officeMapDisableDragging: "Disable dragging",
	officeMapEnableDragging: "Enable dragging",
	officeMapEndDeviceOptional: "End device (optional)",
	officeMapFailedToMoveCable: "Failed to move cable",
	officeMapFailedToMoveItem: "Failed to move item",
	officeMapFailedToMoveRoomArea: "Failed to move room area",
	officeMapFailedToOpenChat: "Failed to open chat",
	officeMapFailedToPlaceItem: "Failed to place item",
	officeMapFailedToPlaceUser: "Failed to place user",
	officeMapFailedToRemoveCable: "Failed to remove cable",
	officeMapFailedToRemoveItem: "Failed to remove item",
	officeMapFailedToRemoveRoomArea: "Failed to remove room area",
	officeMapFailedToSaveCableLine: "Failed to save cable line",
	officeMapFailedToSaveRoomArea: "Failed to save room area",
	officeMapFinishArea: "Finish Area",
	officeMapFinishCable: "Finish Cable",
	officeMapFloor: "Floor",
	officeMapFloorSelector: "Office / Floor",
	officeMapForbidden: "Forbidden",
	officeMapIp: "IP",
	officeMapItem: "Item",
	officeMapItemPlaced: "Item placed",
	officeMapItemRemovedFromMap: "Item removed from map",
	officeMapLaptop: "Laptop",
	officeMapLaptops: "Laptops",
	officeMapLayers: "Layers",
	officeMapLinkedItRoom: "Linked IT room",
	officeMapLive: "Live",
	officeMapMac: "MAC",
	officeMapMin: "min",
	officeMapMonitors: "Monitors",
	officeMapNetworkCable: "Network Cable",
	officeMapNoDevicesInArea: "No devices or users placed in this area.",
	officeMapNoPermissionToPlaceItem: "You do not have permission to place this item.",
	officeMapNoPermissionToPlaceNetworkCable: "You do not have permission to place a network cable.",
	officeMapNoPermissionToPlaceRoomArea: "You do not have permission to place a room area.",
	officeMapNoPermissionToRemoveItem: "You do not have permission to remove this item from the map.",
	officeMapNoPermissionToRemoveNetworkCable:
		"You do not have permission to remove the network cable from the map.",
	officeMapNoPermissionToRemoveRoomArea:
		"You do not have permission to remove the room area from the map.",
	officeMapNotAvailable: "N/A",
	officeMapNotConnected: "Not connected",
	officeMapPc: "PC",
	officeMapPcs: "PCs",
	officeMapPlacement: "Placement",
	officeMapPleaseSelectItemFirst: "Please select an item first",
	officeMapPleaseSelectRoomFirst: "Please select a room first",
	officeMapPoints: "Points",
	officeMapPorts: "Ports",
	officeMapPrinted: "Printed",
	officeMapPrinters: "Printers",
	officeMapRam: "RAM",
	officeMapRemoveFromMap: "Remove from Map",
	officeMapRom: "ROM",
	officeMapRoomArea: "Room Area",
	officeMapRoomAreaPlaced: "Room area was placed",
	officeMapRoomAreaRemovedFromMap: "Room area removed from map",
	officeMapRoomAreas: "Rooms",
	officeMapRoomContents: "Room contents",
	officeMapRouter: "Router",
	officeMapRouters: "Routers",
	officeMapOffice: "Office",
	officeMapSelectFloor: "Select floor",
	officeMapSelectOffice: "Select office",
	officeMapSelectOfficeAndFloorHelp:
		"Choose an office and floor to load only that floor's map and infrastructure.",
	officeMapSelectOfficeAndFloorTitle: "Select an office and floor",
	officeMapSelectOfficeFirst: "Select an office first",
	officeMapSelectItem: "Select item",
	officeMapSelectRoom: "Select room",
	officeMapSpeed: "Speed",
	officeMapStartDeviceOptional: "Start device (optional)",
	officeMapSwitches: "Switches",
	officeMapTelephone: "Telephone",
	officeMapTelephones: "Telephones",
	officeMapUnknown: "Unknown",
	officeMapUrl: "URL",
	officeMapUserPlacedOnMap: "User placed on map",
	officeMapUsers: "Users",
	officeMapViewContents: "View contents",
	officeMapViewFullDetails: "View Full Details",
	offline: "Offline",
	offlinePaymentOnly: "Offline payment only",
	oldProject: "Old Project",
	onSale: "On Sale",
	onSecond: "On second",
	onTime: "On Time",
	onTimeRate: "On-Time Rate",
	oneOf: "One of",
	open: "Open",
	openBoard: "Open Board",
	openDate: "Date opened",
	openInModal: "Open in modal",
	openInNewTab: "Open in new tab",
	openNavigation: "Open navigation",
	openedDate: "Open Date",
	optional: "Optional",
	orClickToSelect: "or click to select files",
	order: "Order",
	orderNumber: "Order number",
	orders: "Orders",
	ordersCart: "Orders Chart",
	otAfterWork: "Overtime after work",
	otBeforeWork: "Overtime before work",
	otHours: "OT Hours",
	otRate: "OT Rate",
	maintenanceSchedule: "Maintenance schedule",
	otherBenefits: "Other Benefits",
	otherDeductions: "Other Deductions",
	otherInsurance: "Other Insurance",
	outOfStock: "Out of Stock",
	overdue: "Overdue",
	overtime: "Overtime",
	overtimeComment: "Overtime comment",
	overtimeDays: "Overtime days",
	overtimeHours: "Overtime Hours",
	overtimeRate: "Overtime Rate",
	overtimeSummary: "Overtime summary",
	overtimeTotal: "Total overtime",
	overview: "Overview",
	owner: "Owner",
	ownership: "Ownership",
	pageNotFound: "Page Not Found",
	pageNotFoundDescription:
		"Oops! The page you are looking for doesn't exist or has been moved. It might have been removed, had its name changed, or is temporarily unavailable.",
	pages: "Pages",
	paid: "Paid",
	paidStatus: "Paid Status",
	paidTimeOff: "Paid Time Off",
	paidTimeOffDays: "Paid Time Off Days",
	parent: "Parent",
	parentCategory: "Parent category",
	parentDepartment: "Parent Department",
	parentTask: "Parent Task",
	parentType: "Parent Type",
	parentUser: "Parent User",
	participant: "Participant",
	passportEndDate: "Passport End Date",
	passportImages: "Passport images",
	passportNo: "Passport No",
	passportStartDate: "Passport Start Date",
	password: "Password",
	pause: "Pause",
	paused: "Paused",
	payDate: "Pay Date",
	paymentMethod: "Payment method",
	paymentMethods: "Payment Methods",
	paymentSystem: "Payment System",
	payrollBreakdown: "Payroll Breakdown",
	payrollCalcError: "Payroll calculation failed.",
	payrollCalcHint: "Employee and period are required. Click to calculate and save payroll totals.",
	payrollCalcMissingFields: "Please select employee, period start, and period end.",
	payrollCommentsForEmployee: "Comments for Employee",
	payrollGeneratedFromAttendance: "Payroll generated from attendance",
	payrollHealthInsurancePremium: "Health insurance (premium)",
	payrollIndexLabel: "Index",
	payrollIndexPlaceholder: "Index",
	payrollInternalNotes: "Internal Notes",
	payrollNotesSection: "Notes",
	payrollType: "Payroll Type",
	payrollUsesHrSettings:
		"Overtime, tax rates, and default benefits (lunch, transport, health) follow HR settings (System → HR settings).",
	pc: "Computer",
	pcHealth: "PC Health",
	pcs: "PCs",
	pdf: "PDF",
	penalties: "Penalties",
	pending: "Pending",
	pensionAmount: "Pension Amount",
	pensionRate: "Pension Rate",
	period: "Period",
	periodEnd: "Period End",
	periodStart: "Period Start",
	periud: "Period",
	permInput_calendarEvent_overlayCustomCalendars: "Custom calendars (filter toggles)",
	permInput_calendarEvent_overlayIt: "IT calendars (PC warranty overlays)",
	permInput_calendarEvent_overlayPeople: "People calendars (HR date overlays)",
	permInput_calendarEvent_overlayReminders: "Reminders overlay",
	permInput_calendarEvent_overlayTasks: "Tasks overlay (priority layers)",
	permInput_calendarEvent_overlayTickets: "Tickets overlay (deadlines by domain)",
	permInput_chat_attachFile: "Attach files",
	permInput_chat_calling: "Audio calling",
	permInput_chat_pin: "Pin messages",
	permInput_chat_searchFiles: "Search in files",
	permInput_chat_searchMessages: "Search in messages",
	permInput_chat_sendMessage: "Send messages",
	permInput_chat_star: "Star messages",
	permInput_chat_videoCalling: "Video calling",
	permModuleCrud_download: "Calendar download (import .ics)",
	permModuleCrud_upload: "Calendar upload (export .ics)",
	permanentDelete: "Permanent Delete?",
	permission: "Permission",
	permissions: "Permissions",
	persons: "Persons",
	phone: "Phone",
	photo: "Photo",
	photos: "Photos",
	pickEmoji: "Pick emoji",
	pinnedMessages: "Pinned messages",
	placed: "Placed",
	placedState: "Placed state",
	placeholder: "Placeholder",
	platformDashboard: "Platform Dashboard",
	platformSpecificSettings: "Platform specific settings",
	platforms: "Platforms",
	audioPlaybackSpeed: "Playback speed: {rate}. Click to change.",
	playbackMute: "Mute",
	playbackUnmute: "Unmute",
	playbackVoiceMessage: "Voice message",
	playbackVideoMessage: "Video message",
	previewVoiceMessage: "Preview voice message",
	play: "Play",
	playStatus: "Play status",
	playing: "Playing",
	playingComposition: "Playing composition",
	playingHistory: "Playing history",
	playlist: "Playlist",
	playlistStatistics: "Playlist Statistics",
	playlistsWithAds: "playlists with advertisements",
	playlistsWithoutAds: "playlists without advertisements",
	podcast: "Podcast",
	podcastStreams: "podcast streams",
	podcasts: "Podcasts",
	ports: "Ports",
	position: "Position",
	positionReviewDate: "Position Review Date",
	preDefinedFilters: "Pre-defined filters",
	present: "Present",
	preview: "Preview",
	previous: "Previous",
	previousStep: "Previous step",
	price: "Price",
	priceB2b: "Price Corporate",
	priceBasic: "Price Basic",
	priceGroup1: "Price Group 1",
	priceGroup2: "Price Group 2",
	priceGroup3: "Price Group 3",
	priceLists: "Price Lists",
	printedCount: "Printed Count",
	printer: "Printer",
	printers: "Printers",
	priority: "Priority",
	priorityDescription: "Priority description",
	private: "Private",
	privateChat: "Private Chat",
	privateChatDescription: "Only selected users can see and join this chat",
	problem: "Problem",
	problemDescription: "Problem Description",
	problemGroup: "Problem Group",
	problemGroupSupervisorsPlaceholder:
		"Users responsible for handling tickets in this problem group",
	problemGroupSupervisorsTab: "Supervisors",
	processTime: "Process Time",
	processing: "Processing",
	progress: "Progress",
	product: "Product",
	productCare: "Product Care",
	products: "Products",
	productsLinked: "Products linked",
	project: "Project",
	projectChanges: "Project Changes",
	projectDeadline: "Project Deadline",
	projectDetails: "Project Details",
	projectEndDate: "Project End Date",
	projectID: "Project ID",
	projectPartition: "Project Partition",
	projectPrice: "Project price",
	projectPrice2: "Project price",
	projectStartDate: "Project Start Date",
	projectType: "Project Type",
	projectTypes: "Project Types",
	projects: "Projects",
	promoCode: "Promo code",
	promoCodes: "Promo Codes",
	promoCodesAndCertificates: "Promo Codes and Certificates",
	promotions: "Promotions",
	propertyNumber: "Property number",
	providing: "Providing",
	punchActivity: "Punch activity",
	pto: "PTO",
	partial: "Partial",
	quantity: "Quantity",
	qrCode: "QR code",
	radioDashboard: "Radio Dashboard",
	radioManagementOverview: "Overview of radio streaming management",
	radioStatistics: "Radio Statistics",
	raises: "Raises",
	ram: "RAM",
	rate: "Rate",
	rating: "Rating",
	readOnly: "Read only",
	readOnlyChatNotice: "This chat is read-only for members. Only admins can write messages.",
	readyToGetStarted: "Ready to get started",
	recalculatePayroll: "Recalculate Payroll",
	recentClients: "Recent Clients",
	recentContent: "Recent Content",
	recentMessages: "Recent Messages",
	recentOrders: "Recent Orders",
	recentTickets: "Recent Tickets",
	recentTracks: "Recent Tracks",
	refresh: "Refresh",
	registeredAddress: "Registered Address",
	regularHours: "Regular Hours",
	regularHoursHrScheduleHint:
		"Autofilled from HR settings: weekdays in the period × working hours per day. Editable.",
	regularPlaylists: "Regular Playlists",
	relatedList: "Related List",
	relatedObjects: "Related Objects",
	relatedProducts: "Related products",
	relatedTasks: "Related Tasks",
	relations: "Relations",
	remainingVacation: "Remaining vacation",
	remote: "Remote",
	remoteWorkDays: "Remote Work Days",
	remove: "Remove",
	removeFromList: "Remove from list",
	removeItem: "Remove Item",
	removed: "Removed",
	reopen: "Reopen",
	repair: "Repair",
	repairHistory: "Repair history",
	replaceableProduct: "Replaceable product",
	replaceableProducts: "Replaceable products",
	replacementDate: "Replacement date",
	replied: "Replied",
	reply: "Reply",
	request: "Request",
	requestedForUser: "Requested For",
	reset: "Reset",
	responseTimeDistribution: "Response Time Distribution",
	responsible: "Responsible",
	responsibleAndUsers: "Responsible and Users",
	restoreSelected: "Restore Selected",
	restored: "Restored",
	retired: "Retired",
	returnDocument: "Return document",
	returning: "Returning",
	revenue: "Revenue",
	revenueOverview: "Revenue Overview",
	review: "Review",
	rightNow: "Right now",
	role: "Role",
	rom: "ROM",
	room: "Room",
	routers: "Routers",
	rpaPrice: "RPA department work price",
	ruleName: "Rule name",
	salary: "Salary",
	salaryReviewDate: "Salary Review Date",
	sale: "Sale",
	forSale: "For Selling",
	forBuying: "For Buying",
	productsForBuying: "Products for buying",
	productsForSelling: "Products for selling",
	supplier: "Supplier",
	customers: "Customers",
	store: "Stores",
	stores: "Stores",
	shopping: "Shopping",
	salePrice: "Sale Price",
	salesBreakdownByCategory: "Sales Breakdown by Category",
	salesPerformanceOverTime: "Sales Performance Over Time",
	sat: "Saturday",
	save: "Save",
	saveChanges: "Save Changes",
	saveComment: "Save comment",
	saved: "Saved",
	schedulingDisabled: "Scheduling disabled",
	schedulingEnabled: "Scheduling enabled",
	schedulingRules: "Schedule rules",
	search: "Search",
	searchByNameOrId: "Search by name or ID…",
	searchChat: "Search chat...",
	searchChatGroups: "Search chat groups...",
	searchConversations: "Search conversations...",
	searchResults: "Search Results",
	searchUsers: "Search users...",
	secondary: "Secondary",
	seconds: "seconds",
	securityAcknowledge: "Acknowledge",
	securityActions: "Actions",
	securityActiveBadge: "Active",
	securityActiveSessions: "Active Sessions",
	securityActivityStatClicks: "Clicks",
	securityActivityStatKeys: "Keys",
	securityActivityStatMoves: "Moves",
	securityActivityTimeline: "Activity Timeline",
	securityAdminNotes: "Admin notes",
	securityAdminNotesDevice: "Internal notes about this device...",
	securityAgentHeartbeat: "Agent heartbeat",
	securityAlertClipPlural: "alert-triggered clips on this page",
	securityAlertClipSingular: "alert-triggered clip on this page",
	securityAlertCount: "alert",
	securityAlertCountPlural: "alerts",
	securityAlertDrawerNoMedia:
		"No media is linked to this alert yet. The security agent on the device must run FFmpeg to record and upload video. On Windows, FFmpeg must be on PATH or set via FFMPEG_PATH. Check the agent log for capture commands and upload errors.",
	securityAlertDrawerVideoFailed:
		"A video capture command was issued but no footage was uploaded. The agent may have encountered an error — check the agent log on the device for upload errors.",
	securityAlertDrawerVideoPending:
		"Video is being recorded and will appear here shortly. The agent on the device is capturing footage and uploading it now.",
	securityAlertRecordings: "Alert Recordings",
	securityAlertRecordingsOnly: "Alert recordings only",
	securityAlertSt_acknowledged: "acknowledged",
	securityAlertSt_false_positive: "false positive",
	securityAlertSt_open: "open",
	securityAlertSt_resolved: "resolved",
	securityAlertsTitle: "Security Alerts",
	securityAllDevices: "All devices",
	securityAllEventTypes: "All types",
	securityAllRules: "All rules",
	securityAllSeverities: "All severities",
	securityAllStatuses: "All statuses",
	securityAppProcessTracking: "App / Process Tracking",
	securityAppTracking: "App Tracking",
	securityAppUsageToday: "App Usage Today (minutes)",
	securityAssignedUser: "Assigned User",
	securityBadgeAlertText: "ALERT",
	securityBadgeApp: "app",
	securityBadgeApps: "Apps",
	securityBadgeCapture: "capture",
	securityBadgeFiles: "Files",
	securityBadgeOff: "off",
	securityBadgeScr: "scr",
	securityBadgeScreenshot: "Screenshot",
	securityBadgeVideo: "Video",
	securityBadgeWeb: "Web",
	securityCapture: "Capture",
	securityCaptureEnabledMaster: "Capture Enabled (master)",
	securityCaptureEverySeconds: "Capture every (seconds)",
	securityCaptureMasterSwitch: "Capture Enabled (master switch)",
	securityCaptureModes: "Capture Modes",
	securityCaptureOffAlertBody:
		"Capture is explicitly disabled at device level, overriding the policy. Alerts fire but no screenshots or video are recorded.",
	securityCaptureOffAlertTitle: "Capture override: OFF",
	securityCaptureRecorded: "Capture recorded",
	securityCaptureWhenOnDesc:
		"When on, screenshots and video recording can be active; turning off disables both",
	securityChartMinutes: "minutes",
	securityChartVisits: "visits",
	securityClearFilters: "Clear filters",
	securityClickLeft: "L",
	securityClickMiddle: "M",
	securityClickPlain: "click",
	securityClickRight: "R",
	securityClientsAccuracyApproximateOnly: "Accuracy: approximate only",
	securityClientsActions: "Actions",
	securityClientsActivity: "Activity",
	securityClientsAny: "Any",
	securityClientsApproximateGeo: "Approximate geo",
	securityClientsApproximateGeoOnly: "Approximate geo only",
	securityClientsApproximateLocationUnavailable: "Approximate location unavailable",
	securityClientsApproximateOriginsOnly:
		"Approximate origins only. Markers are grouped for privacy and performance.",
	securityClientsBlocked: "Blocked",
	securityClientsBlockedIp: "Blocked IP",
	securityClientsBlockedRequestPressure: "Blocked request pressure",
	securityClientsBrowser: "Browser",
	securityClientsCardAcrossLast: "Across the last",
	securityClientsCardActiveDenyEntriesSubtitle:
		"Active deny entries currently enforced at the API edge",
	securityClientsCardActiveSessions: "Active sessions",
	securityClientsCardApproximateGeographiesSubtitle:
		"Approximate geographies represented on the map",
	securityClientsCardBlockedIpRules: "Blocked IP rules",
	securityClientsCardConnectedDevices: "Connected devices",
	securityClientsCardCountries: "Countries",
	securityClientsCardDistinctUsersSubtitle: "Distinct users behind active or connected sessions",
	securityClientsCardLightweightRiskSignalsSubtitle:
		"Lightweight risk signals based on location, device, and policy data",
	securityClientsCardMinuteActivityWindow: "minute activity window",
	securityClientsCardSuspiciousSessions: "Suspicious sessions",
	securityClientsCardUsersOnline: "Users online",
	securityClientsCardWithLiveSocketPresence: "with live socket presence",
	securityClientsClusters: "Clusters",
	securityClientsConnectionMap: "Connection map",
	securityClientsCountry: "Country",
	securityClientsCurrent: "Current",
	securityClientsDays: "days",
	securityClientsDenied: "Denied",
	securityClientsDevice: "Device",
	securityClientsDeviceBrowserOnOs: "{browser} on {os}",
	securityClientsDevices: "Devices",
	securityClientsDisconnectAll: "Disconnect all",
	securityClientsDisconnectAllSessionsForCurrentUserText:
		"All other sessions for your account will be revoked. Your current session will stay active.",
	securityClientsDisconnectAllSessionsForTargetUserText:
		"Every active session for this user will be revoked immediately.",
	securityClientsDisconnectAllSessionsForUserTitle: "Disconnect all sessions for this user?",
	securityClientsDisconnectAllUserSessions: "Disconnect all user sessions",
	securityClientsDisconnectSession: "Disconnect session",
	securityClientsDisconnectThisSessionText:
		"The selected client session will be forced to sign in again immediately.",
	securityClientsDisconnectThisSessionTitle: "Disconnect this session?",
	securityClientsExpires: "Expires",
	securityClientsFailedToLoadDataTitle: "Clients data failed to load",
	securityClientsFilterActiveAndRecent: "Active + recent",
	securityClientsFiltersDescription:
		"Filter by activity, geography, device stack, blocked network status, or lightweight risk signals.",
	securityClientsFiltersTitle: "Filters and search",
	securityClientsFirstSeen: "First seen",
	securityClientsLastActive: "Last active",
	securityClientsLastDenied: "Last denied",
	securityClientsLiveInventoryDescription:
		"Use the grouped device view for quick fleet patterns or the session view for precise user and IP actions.",
	securityClientsLiveInventoryTitle: "Live clients inventory",
	securityClientsLiveMonitoring: "Live monitoring",
	securityClientsLiveSocketUpdates: "Live socket updates",
	securityClientsLocationPrivacyNote:
		"Location markers use approximate IP geolocation and may reflect a gateway, ISP, VPN, or office egress point rather than an exact device position.",
	securityClientsMapFailedToLoad: "Map failed to load",
	securityClientsMapProviderNotConfigured: "Map provider not configured",
	securityClientsMostActiveUsers: "Most active users",
	securityClientsNetworkAndLocation: "Network and location",
	securityClientsNoActiveUsersForFilters: "No active users found for this filter set.",
	securityClientsNoApproximateGeoPoints:
		"No approximate geolocation points are available for the current filter set yet.",
	securityClientsNoBlockedRequestActivity:
		"No blocked request activity has been recorded in the last 24 hours.",
	securityClientsNoDataYet: "No data yet.",
	securityClientsNoEmail: "No email",
	securityClientsNoMatchingResults: "No sessions or devices match the current filter set.",
	securityClientsNoSuspiciousPatterns:
		"No suspicious patterns are currently flagged by the lightweight heuristics.",
	securityClientsNoUsersAcrossMultipleDevices:
		"No users are spread across multiple devices right now.",
	securityClientsNotBlocked: "Not blocked",
	securityClientsOf: "of",
	securityClientsOn: "on",
	securityClientsOperatingSystem: "Operating system",
	securityClientsPrimaryUser: "Primary user",
	securityClientsRecentActivityWindow: "Recent activity window:",
	securityClientsRefreshLiveData: "Refresh live data",
	securityClientsReset: "Reset",
	securityClientsRetryLoading: "Retry loading",
	securityClientsRisk: "Risk",
	securityClientsRiskHigh: "High",
	securityClientsRiskLow: "Low",
	securityClientsRiskMedium: "Medium",
	securityClientsRiskNormal: "Normal",
	securityClientsRiskSignals: "Risk signals",
	securityClientsSignalBlockedAttemptsDescription:
		"{count} requests were denied by IP policy enforcement.",
	securityClientsSignalBlockedAttemptsTitle: "Blocked IP requests in the last 24 hours",
	securityClientsSignalBlockedIpSessionsDescription:
		"{count} monitored sessions are associated with an actively blocked IP policy entry.",
	securityClientsSignalBlockedIpSessionsTitle: "Sessions still visible from blocked IPs",
	securityClientsSignalManyDevicesDescription:
		"Seen on {count} distinct devices inside the active monitoring window.",
	securityClientsSignalManyDevicesTitle: "{user} has many devices",
	securityClientsSignalMultiCountryDescription:
		"Recent activity spans {count} countries in the last 24 hours.",
	securityClientsSignalMultiCountryTitle: "{user} active across multiple countries",
	securityClientsSignalSeverityCritical: "Critical",
	securityClientsSignalSeverityInfo: "Info",
	securityClientsSignalSeverityWarning: "Warning",
	securityClientsSearchPlaceholder: "Search by user, email, IP address, or device label",
	securityClientsSecurityActionFailed: "Security action failed",
	securityClientsSecurityCenter: "Security center",
	securityClientsSecurityUpdated: "Security updated",
	securityClientsSessionDisconnected: "Session disconnected.",
	securityClientsSessions: "Sessions",
	securityClientsSetEnvToEnableMapPrefix: "Set",
	securityClientsSetEnvToEnableMapSuffix: "to enable the live geographic view.",
	securityClientsSharedDevice: "Shared device",
	securityClientsShowing: "Showing",
	securityClientsStatus: "Status",
	securityClientsStatusActive: "Active",
	securityClientsStatusConnected: "Connected",
	securityClientsStatusRecent: "Recent",
	securityClientsStatusRevoked: "Revoked",
	securityClientsStatusStale: "Stale",
	securityClientsSubtitle:
		"Monitor all connected and recently active client sessions, understand where they are coming from, spot risky patterns early, and take immediate containment action without leaving the Security module.",
	securityClientsSuspicious: "Suspicious",
	securityClientsSuspiciousSessions: "Suspicious sessions",
	securityClientsSyncingLiveChanges: "Syncing live changes...",
	securityClientsTitle: "Security Clients",
	securityClientsTopBrowsers: "Top browsers",
	securityClientsTopCountries: "Top countries",
	securityClientsTopOperatingSystems: "Top operating systems",
	securityClientsUnableToDisconnectSelectedSession: "Unable to disconnect the selected session.",
	securityClientsUnableToDisconnectUserSessions: "Unable to disconnect the user's sessions.",
	securityClientsUnableToLoadDashboard: "Unable to load the Security Clients dashboard.",
	securityClientsUnableToLoadGoogleMaps: "Unable to load Google Maps right now.",
	securityClientsUnknownBrowser: "Unknown browser",
	securityClientsUnknownDevice: "Unknown device",
	securityClientsUnknownIp: "Unknown IP",
	securityClientsUnknownOs: "Unknown OS",
	securityClientsUnknownUser: "Unknown user",
	securityClientsUnknownUserInitial: "U",
	securityClientsUpdated: "Updated",
	securityClientsUser: "User",
	securityClientsUserSessionsDisconnected: "User sessions disconnected.",
	securityClientsUsers: "Users",
	securityClientsUsersSeenOnDevice: "users seen on this device",
	securityClientsUsersWithMultipleDevices: "Users with multiple devices",
	securityClientsViewUserSecurity: "View user security",
	securityClipWord: "Clip",
	securityConnectedDevices: "Connected Devices",
	securityCreated: "Created",
	securityDeleteDevice: "Delete Device",
	securityDeleteDeviceConfirm: "Are you sure you want to delete",
	securityDeleteDeviceNote:
		"This removes only the security device record. The PC profile in IT will not be affected.",
	securityDeleteDeviceTitle: "Delete Security Device",
	securityDeleteMedia: "Delete",
	securityDeletePolicyConfirm: "Delete this policy?",
	securityDevice: "Device",
	securityDeviceFallback: "Device",
	securityDeviceIdLabel: "Device ID",
	securityDeviceNotFound: "Device not found",
	securityDeviceSettings: "Device settings",
	securityDeviceSettingsHint:
		"Overrides the active policy for this device. Inherited from policy when not explicitly set.",
	securityDevicesBreadcrumb: "Devices",
	securityDevicesTitle: "Security Devices",
	securityDevicesWithAlerts: "Devices w/ Alerts",
	securityDividerCapture: "Capture",
	securityDividerNotes: "Notes",
	securityDividerTracking: "Tracking",
	securityDuration: "Duration",
	securityEg15: "e.g. 15",
	securityEg30: "e.g. 30",
	securityEg300: "e.g. 300",
	securityEg5: "e.g. 5",
	securityEg60: "e.g. 60",
	securityEnabled: "Enabled",
	securityEnd: "End",
	securityEventFlushSeconds: "Event flush (seconds)",
	securityEventsCount: "event",
	securityEventsCountPlural: "events",
	securityEvtAppProcess: "App / Process",
	securityEvtAppUsage: "App Usage",
	securityEvtFileEvent: "File Event",
	securityEvtHeartbeat: "Heartbeat",
	securityEvtInputActivity: "Input Activity",
	securityEvtKeystroke: "Keystroke",
	securityEvtMouseClick: "Mouse Click",
	securityEvtSessionEnd: "Session end",
	securityEvtSessionStart: "Session start",
	securityEvtSystemBoot: "System boot",
	securityEvtSystemShutdown: "System shutdown",
	securityEvtUsb: "USB Event",
	securityEvtUserLogin: "User login",
	securityEvtUserLogout: "User logout",
	securityEvtWebVisit: "Web Visit",
	securityEvtWorkstationLock: "Screen locked",
	securityEvtWorkstationUnlock: "Screen unlocked",
	securityFailedLoadOverview: "Failed to load security overview",
	securityFailedSavePolicy: "Failed to save policy",
	securityFalsePositiveBtn: "False Positive",
	securityFileEventTracking: "File Event Tracking",
	securityFilterByDate: "Filter by date",
	securityFilterDateRange: "Filter by date range",
	securityFilteredSuffix: "(filtered)",
	securityFps: "FPS",
	securityHostname: "Hostname",
	securityInputActivityCounts: "Input activity (counts)",
	securityInputKeystrokeClickTracking: "Input Keystroke/Click Tracking",
	securityInputModeActivityCountsShort: "Activity only — key/click counts",
	securityInputModeActivityOnly: "Activity only (counts)",
	securityInputModeDisabled: "Disabled",
	securityInputModeDisabledShort: "Disabled — no input metrics",
	securityInputModeEventsOnly: "Events only",
	securityInputModeEventsStream: "Events only — raw event stream",
	securityInputModeFullDetail: "Full detail (keystrokes + clicks)",
	securityInputModeFullKeystrokes: "Full detail — keystrokes + click positions",
	securityInputModeShort: "Input Mode",
	securityInputTrackingMode: "Input Tracking Mode",
	securityInternalNotesPlaceholder: "Internal notes...",
	securityIpPolicyActions: "Actions",
	securityIpPolicyActive: "Active",
	securityIpPolicyAllow: "Allow",
	securityIpPolicyAppliesToAllIps: "Apply this login allow window to all IP addresses",
	securityIpPolicyAllowRuleSaved: "Allow rule saved",
	securityIpPolicyAllowRuleSavedMessage: "The allow rule has been saved.",
	securityIpPolicyBlock: "Block",
	securityIpPolicyBlockIp: "Block IP",
	securityIpPolicyCreatedBy: "Created by",
	securityIpPolicyCurrentEntries: "Current entries",
	securityIpPolicyDeactivate: "Deactivate",
	securityIpPolicyDeactivateAllowRuleText:
		"This IP address will no longer bypass matching block rules.",
	securityIpPolicyDeactivateAllowRuleTitle: "Deactivate this allow rule?",
	securityIpPolicyEntryDeactivatedMessage: "The IP policy entry has been deactivated.",
	securityIpPolicyExpires: "Expires",
	securityIpPolicyExpiresAt: "Expires at",
	securityIpPolicyExpiresAtPlaceholder: "Optional temporary expiration",
	securityIpPolicyFailedToLoadTitle: "Failed to load IP policy",
	securityIpPolicyFailedToSaveTitle: "Failed to save IP policy",
	securityIpPolicyFailedToUnblockTitle: "Failed to unblock IP",
	securityIpPolicyGlobalApiEnforcement: "Global API enforcement",
	securityIpPolicyInactive: "Inactive",
	securityIpPolicyIntroText:
		"Entries are matched against the normalized client IP address. Location data elsewhere in the platform stays explicitly approximate and should not be treated as exact physical location.",
	securityIpPolicyIp: "IP",
	securityIpPolicyIpAddress: "IP address",
	securityIpPolicyIpAddressBlocked: "IP address blocked.",
	securityIpPolicyIpAddressUnblocked: "IP address unblocked.",
	securityIpPolicyIpBlocked: "IP blocked",
	securityIpPolicyIpBlockedMessage: "The IP address has been added to the block policy.",
	securityIpPolicyIpUnblocked: "IP unblocked",
	securityIpPolicyLastMatched: "Last matched",
	securityIpPolicyMatches: "Matches",
	securityIpPolicyNewEntry: "New policy entry",
	securityIpPolicyNoEntriesFound: "No IP policy entries found.",
	securityIpPolicyNotes: "Notes",
	securityIpPolicyNotesPlaceholder: "Operational notes for admins",
	securityIpPolicyOperationalNotesOptional: "Operational notes (optional)",
	securityIpPolicyReason: "Reason",
	securityIpPolicyReasonOptional: "Reason (optional)",
	securityIpPolicyReasonPlaceholder: "Repeated suspicious login attempts",
	securityIpPolicyRemoveIpBlockText:
		"This IP address will no longer be blocked by the platform policy.",
	securityIpPolicyRemoveIpBlockTitle: "Remove this IP block?",
	securityIpPolicyRuleType: "Rule type",
	securityIpPolicySaveEntry: "Save policy entry",
	securityIpPolicyShowInactive: "Show inactive",
	securityIpPolicyScope: "Scope",
	securityIpPolicyScopeApi: "API-wide",
	securityIpPolicyScopeLogin: "Login only",
	securityIpPolicyStatus: "Status",
	securityIpPolicyStarts: "Starts",
	securityIpPolicyStartsAt: "Starts at",
	securityIpPolicyStartsAtPlaceholder: "Optional start time for the rule",
	securityIpPolicyTitle: "IP block and allow policy",
	securityIpPolicyLockdownTitle: "Block all external logins",
	securityIpPolicyLockdownDesc:
		"When on, users not bound to any login allow rule can sign in only from a configured office IP. Add office IPs below or use login allow rules without user binding.",
	securityIpPolicyLockdownOn: "On",
	securityIpPolicyLockdownOff: "Off",
	securityIpPolicyLockdownSavedTitle: "Lockdown updated",
	securityIpPolicyLockdownOnMessage: "External logins are now restricted to approved office IPs.",
	securityIpPolicyLockdownOffMessage: "Non-restricted users can now sign in from anywhere.",
	securityIpPolicyOfficeIpsTitle: "Office IPs",
	securityIpPolicyOfficeIpsDesc:
		"Network addresses treated as the office. When lockdown is on, logins from these IPs are allowed; all other IPs are blocked unless the user is on the trusted users list.",
	securityIpPolicyOfficeIpsPh: "Type an office IP and press Enter",
	securityIpPolicyOfficeIpsSave: "Save office IPs",
	securityIpPolicyOfficeIpsSavedTitle: "Office IPs updated",
	securityIpPolicyOfficeIpsSavedMessage:
		"Office network addresses are saved. Lockdown will treat these as in-office locations.",
	securityIpPolicyTrustedUsersTitle: "Users allowed from office and outside",
	securityIpPolicyTrustedUsersDesc:
		"These users may sign in from anywhere — office or outside — even while lockdown is on. Hard IP blocks still apply.",
	securityIpPolicyTrustedUsersPh: "Choose trusted users",
	securityIpPolicyTrustedUsersSave: "Save trusted users",
	securityIpPolicyTrustedUsersSavedTitle: "Trusted users updated",
	securityIpPolicyTrustedUsersSavedMessage: "These users may now sign in from office and outside.",
	securityIpPolicyOfficeBindingTitle: "Office access binding",
	securityIpPolicyOfficeBindingDesc:
		"Bind selected users to these IP(s) and an optional time window. Those users may sign in only from here, during these hours.",
	securityIpPolicyAdditionalIps: "Additional IPs",
	securityIpPolicyAdditionalIpsDesc:
		"Extra approved IPs for this rule, in addition to the primary IP above.",
	securityIpPolicyAdditionalIpsPh: "Type an IP and press Enter",
	securityIpPolicyAddIp: "Add IP",
	securityIpPolicyAppliesToAllUsers: "Apply to all users",
	securityIpPolicyAppliesToAllUsersDesc:
		"Every user must sign in from this rule's IP(s) and window. Equivalent to an office-wide restriction.",
	securityIpPolicySelectedUsers: "Selected users",
	securityIpPolicySelectedUsersDesc:
		"These users may sign in only from this rule's IP(s) during the allowed window.",
	securityIpPolicySelectedUsersPh: "Choose users to restrict",
	securityIpPolicyRecurringWindowTitle: "Allowed time window (optional)",
	securityIpPolicyDaysOfWeek: "Allowed days",
	securityIpPolicyDaysOfWeekDesc: "Leave empty to allow every day.",
	securityIpPolicyDaysOfWeekPh: "Any day",
	securityIpPolicyDailyStart: "From (HH:MM)",
	securityIpPolicyDailyEnd: "To (HH:MM)",
	securityIpPolicyTimezone: "Timezone",
	securityIpPolicyDayMon: "Mon",
	securityIpPolicyDayTue: "Tue",
	securityIpPolicyDayWed: "Wed",
	securityIpPolicyDayThu: "Thu",
	securityIpPolicyDayFri: "Fri",
	securityIpPolicyDaySat: "Sat",
	securityIpPolicyDaySun: "Sun",
	securityIpPolicyUsersColumn: "Users",
	securityIpPolicyWindowColumn: "Time window",
	securityIpPolicyAllUsers: "All users",
	securityIpPolicyAllIps: "All IPs",
	securityIpPolicyInvalidTimeWindow: "Daily times must be in HH:MM format.",
	securityIpPolicyTimeWindowBothRequired:
		"Provide both a start and an end time, or leave both empty.",
	securityIpPolicyType: "Type",
	securityIpPolicyUnableToBlockIpAddress: "Unable to block this IP address.",
	securityIpPolicyUnableToLoadEntries: "Unable to load IP policy entries.",
	securityIpPolicyUnableToSaveEntry: "Unable to save the IP policy entry.",
	securityIpPolicyUnableToUnblockIpAddress: "Unable to unblock this IP address.",
	securityIpPolicyUnableToUpdateEntry: "Unable to update the IP policy entry.",
	securityIpPolicyUnblock: "Unblock",
	securityIpPolicyUnblockIp: "Unblock IP",
	securityIpPolicyUnblockThisIpText:
		"The matching block rule will be deactivated and the IP will stop being denied by policy.",
	securityIpPolicyUnblockThisIpTitle: "Unblock this IP?",
	securityIpPolicyWarningText:
		"Blocked IP entries deny access across the API, not only at login. Use temporary expiration when a short-lived block is safer than a permanent rule.",
	securityKeyCharPrefix: "key:",
	securityLastSeen: "Last Seen",
	securityLatestClip: "Latest clip",
	securityLinkedItPc: "Linked IT PC:",
	securityLiveLoadingSub: "Connecting to the agent — your screen preview will appear in a moment.",
	securityLiveOfflineHint: "Device is offline — live view requires a connected agent.",
	securityLivePressStart: "Press Start live to open the stream.",
	securityLiveScreenAlt: "Live screen",
	securityLiveStatusLive: "Live",
	securityLiveStatusStandby: "Standby",
	securityLiveStreamHint:
		"Stream uses half the native width and height per frame, up to 10 frames per second. The endpoint agent must be running v1.4.0+ with the jimp dependency installed.",
	securityLiveWaitingFrames: "Loading live stream…",
	securityLoggedInSince: "Logged in since",
	securityLoggedOutSince: "Last logout",
	securityMediaPrefix: "Media",
	securityMediaTitle: "Security Media",
	securityMiddleClick: "middle-click",
	securityModuleErrorTitle: "Security module error",
	securityName: "Name",
	securityNearbyScreenshots: "Nearby Screenshots",
	securityNever: "Never",
	securityNewMediaBadge: "new",
	securityNewPolicy: "New Policy",
	securityNoActivityEvents: "No activity events",
	securityNoAlertRecordingsPage: "No alert-triggered recordings on this page",
	securityNoAlertsForDevice: "No alerts for this device",
	securityNoAlertsFound: "No alerts found",
	securityNoDevicesFound: "No devices found",
	securityNoEventsMatchFilter: "No events match this filter",
	securityNoOpenAlerts: "No open alerts",
	securityNoPoliciesConfigured: "No policies configured. Create one to start monitoring.",
	securityNoPreview: "No preview",
	securityNoRiskyDevices: "No risky devices",
	securityNoScreenshotsFound: "No screenshots found",
	securityNoScreenshotsYet: "No screenshots captured yet",
	securityNoSessionsFound: "No sessions found",
	securityNoSessionsRecorded: "No sessions recorded",
	securityNoUserSession: "No user session",
	securityNoUserSessionLiveHint:
		"The PC is on but no user is logged in. Live view and screenshots are not available until someone logs in.",
	securityNoUserSessionTitle: "No user logged in",
	securityNoVideoSegmentsFound: "No video segments found",
	securityNoVideosYet: "No video segments captured yet",
	securityOS: "OS",
	securityOnlineDevices: "Online Devices",
	securityOpenAlerts: "Open Alerts",
	securityOpenPcRecord: "Open PC Record",
	securityOverrideOff: "OFF",
	securityOverrideOn: "ON",
	securityOverridePrefix: "Override:",
	securityOverviewTitle: "Security Overview",
	securityPageOf: "page",
	securityPolActivityTrackingDivider: "Activity Tracking",
	securityPolAfterHoursStart: "After-hours start",
	securityPolAlertClipLength: "Alert video clip length (seconds)",
	securityPolAlertScore: "Alert score (0–100)",
	securityPolAlertSeverity: "Alert severity",
	securityPolAlertVideoDivider: "Alert video recording",
	securityPolAlertVideoInfo:
		"When a rule raises a security alert, the agent records a single desktop video clip using the settings below. The same clip length and quality apply to every rule.",
	securityPolAllowedHoursDivider: "Allowed Capture Hours",
	securityPolBadgeAlert: "Alert",
	securityPolBlockedApps: "Blocked Applications",
	securityPolBlockedAppsPh: "e.g. telegram, discord, torrent",
	securityPolBlockedDomains: "Blocked Domains",
	securityPolBlockedDomainsPh: "e.g. torrent-site.com, telegram.org",
	securityPolBreadcrumbPolicies: "Policies",
	securityPolBulkThreshold: "Bulk file event threshold (events/batch)",
	securityPolBulkThresholdDesc:
		"Number of destructive file events in one upload batch to trigger this rule",
	securityPolCollectInputMetrics: "Collect input activity metrics",
	securityPolCollectInputMetricsDesc: "Mouse/keyboard event counts only (no keystroke content)",
	securityPolCreateAlert: "Create alert",
	securityPolCreateAlertDesc:
		"When this rule matches, open a security alert (video recording uses Capture tab settings)",
	securityPolDescription: "Description",
	securityPolEditPolicy: "Edit Policy",
	securityPolEnableRule: "Enable rule",
	securityPolEventsRetention: "Events retention (days)",
	securityPolEventsRetentionDesc: "Activity event records older than this will be purged",
	securityPolExcludedDomains: "Excluded Domains",
	securityPolExcludedDomainsPh: "e.g. online-banking.com",
	securityPolExcludedProcesses: "Excluded Process Names",
	securityPolExcludedProcessesPh: "e.g. 1Password, Bitwarden",
	securityPolIgnoredAlertDevices: "Ignored alert devices",
	securityPolIgnoredAlertDevicesDesc:
		"Selected devices continue sending activity, but policy rules will not create security alerts or alert recordings for them.",
	securityPolIgnoredAlertDevicesPh: "Search and select devices to ignore for alerts...",
	securityPolInputActivityCounts: "Activity only — counts of mouse/key events",
	securityPolInputDisabledNoTrack: "Disabled — do not track input",
	securityPolInputEventsCount: "Events count — key up/down counts only",
	securityPolInputFullDetail: "Full detail — keystrokes + click positions",
	securityPolInputModeLabel: "Input tracking mode",
	securityPolInputTrackingDivider: "Input Tracking",
	securityPolMaskSensitive: "Mask sensitive windows (e.g. password managers, banking)",
	securityPolMaskSensitiveDesc: "Do not capture screenshots for excluded apps/windows",
	securityPolMaxFps: "Max FPS",
	securityPolMediaRetention: "Media retention (days)",
	securityPolMediaRetentionDesc: "Screenshots and video segments older than this will be deleted",
	securityPolNewSecurityPolicy: "New Security Policy",
	securityPolNotifyUsersDesc:
		"Selected users will receive an in-app notification when any rule in this policy triggers an alert.",
	securityPolNotifyUsersLabel: "Notify administrators on policy trigger",
	securityPolNotifyUsersPh: "Search and select users to notify…",
	securityPolPolicyName: "Policy Name",
	securityPolPolicyNamePh: "e.g. Developer Team Policy",
	securityPolPriority: "Priority",
	securityPolPriorityDesc: "Higher number = evaluated first",
	securityPolRecordVideoOnAlert: "Record video on security alert",
	securityPolRecordVideoOnAlertDesc: "If off, alerts are created but no video is captured",
	securityPolRuleAfterHoursDesc:
		"Fires when activity is detected outside the defined working hours.",
	securityPolRuleAfterHoursLabel: "After-Hours Activity",
	securityPolRuleBlockedAppDesc:
		"Fires when a monitored user opens an application on the blocked list.",
	securityPolRuleBlockedAppLabel: "Blocked Application",
	securityPolRuleBlockedDomainDesc:
		"Fires when a monitored user visits a domain on the blocked list.",
	securityPolRuleBlockedDomainLabel: "Blocked Domain",
	securityPolRuleBulkFileDesc:
		"Fires when a large number of file deletions, renames, or moves occur in a single batch.",
	securityPolRuleBulkFileLabel: "Bulk File Operations",
	securityPolRuleUsbDesc: "Fires when a USB storage device is connected to a monitored device.",
	securityPolRuleUsbLabel: "USB Storage Detected",
	securityPolRulesIntro:
		'Rules define when an event counts as a violation and how the alert is scored. If "Create alert" is on, a security alert is raised and optional video recording follows the Capture tab settings (same for all rules).',
	securityPolSavePolicy: "Save Policy",
	securityPolScope: "Scope",
	securityPolScopeDepartment: "Department",
	securityPolScopeDevice: "Specific devices",
	securityPolScopeGlobal: "Global — applies to all devices",
	securityPolScopeUser: "Specific users",
	securityPolTabCapture: "Capture",
	securityPolTabPrivacy: "Privacy & Exclusions",
	securityPolTabRetention: "Retention",
	securityPolTabRules: "Rules",
	securityPolTrackApps: "Track active applications",
	securityPolTrackFiles: "Track file activity",
	securityPolTrackWebsites: "Track website visits",
	securityPolTrackingMaster: "Tracking enabled (master switch)",
	securityPolTrackingMasterDesc:
		"When off, application, web, file, and input activity tracking are inactive",
	securityPolVisibleNotice: "Show visible monitoring notice to employees",
	securityPolVisibleNoticeDesc:
		"Displays a banner informing the employee that monitoring is active",
	securityPolWorkDayStart: "Work-day start (end of after-hours)",
	securityPolWorkingHours: "Working hours (optional)",
	securityPolWorkingHoursDesc:
		"Only capture during this window. Format: HH:MM-HH:MM e.g. 09:00-18:00. Leave empty for always.",
	securityPolWorkingHoursPh: "09:00-18:00",
	securityPoliciesCaptureHint:
		"Screenshot and video run only when a rule triggers capture (not on a timer). Apps, web, and files follow their switches while the agent runs. Open a policy (pencil) → Capture / Rules.",
	securityPoliciesTitle: "Security Policies",
	securityPolicyDefaultBadge: "Policy default",
	securityPriority: "Priority",
	securityQueued: "Queued!",
	securityRecentOpenAlerts: "Recent Open Alerts",
	securityRecentScreenshots: "Recent Screenshots",
	securityRecordEverySeconds: "Record every (seconds)",
	securityRecordVideo30s: "Record video (30s)",
	securityRefresh: "Refresh",
	securityResolution: "Resolution",
	securityResolutionNotePlaceholder: "Resolution note (optional)",
	securityResolve: "Resolve",
	securityRightClick: "right-click",
	securityRule: "Rule",
	securityRuleCode_AFTER_HOURS: "After Hours",
	securityRuleCode_BLOCKED_APP: "Blocked App",
	securityRuleCode_BLOCKED_DOMAIN: "Blocked Domain",
	securityRuleCode_BULK_FILE_EVENTS: "Bulk File Events",
	securityRuleCode_USB_DETECTED: "USB Detected",
	securitySaveSettings: "Save Settings",
	securitySaved: "Saved",
	securityScope: "Scope",
	securityScopeType_department: "Department",
	securityScopeType_device: "Device",
	securityScopeType_global: "Global",
	securityScopeType_user: "User",
	securityScreenshotAlt: "Screenshot",
	securityScreenshotOptionsBlank: "Screenshot options (blank = use policy default)",
	securityScreenshots: "Screenshots",
	securityScreenshotsCount: "Screenshots",
	securityScreenshotsLabel: "Screenshots",
	securityScreenshotsToday: "Screenshots Today",
	securitySearch: "Search",
	securitySearchDevicesPlaceholder: "Search hostname, device ID, user...",
	securitySegmentLengthSeconds: "Segment length (seconds)",
	securitySelectedCount: "selected",
	securitySessionActive: "Active",
	securitySessionIdle: "Idle",
	securitySessionLocked: "Screen locked",
	securitySessionLockedCaptureHint: "Screen is locked — captures and live view are not available.",
	securitySessionLockedLiveHint:
		"The user has locked the screen. Live view, screenshots, and recordings are disabled while the screen is locked.",
	securitySessionLockedSince: "Locked since",
	securitySessionLockedTitle: "Screen is locked",
	securitySessionNotFound: "Session not found",
	securitySessionTimeline: "Session Timeline",
	securitySessionWord: "Session",
	securitySessionsTitle: "Sessions",
	securitySettingsDrawerTitle: "Settings",
	securitySettingsOverrideHint:
		"These override the active policy for this device only. Leave as-is to inherit from policy.",
	securitySev_critical: "critical",
	securitySev_high: "high",
	securitySev_low: "low",
	securitySev_medium: "medium",
	securitySeverity: "Severity",
	securityShowAllVideos: "Show all videos",
	securitySourceEvents: "Source Events",
	securitySpeedSec: "Speed (sec):",
	securityStart: "Start",
	securityStartLive: "Start live",
	securityStatOf: "of",
	securityStatus: "Status",
	securityStatus_error: "Error",
	securityStatus_offline: "Offline",
	securityStatus_online: "Online",
	securityStatus_pending: "Pending",
	securityStatus_unknown: "unknown",
	securityStopLive: "Stop live",
	securityTabActivity: "Activity",
	securityTabAlerts: "Alerts",
	securityTabLive: "Live",
	securityTabScreenshots: "Screenshots",
	securityTabSessions: "Sessions",
	securityTabSettings: "Settings",
	securityTabVideos: "Videos",
	securityTakeScreenshot: "Take screenshot",
	securityTitle: "Title",
	securityTooltipAppTrack: "Toggle app/process tracking",
	securityTooltipCaptureMaster:
		"Toggle screenshot & media capture (master — also enables or disables screenshot and video toggles)",
	securityTooltipScreenshot: "Toggle screenshot capture",
	securityTooltipTrackingMaster: "Master switch for app, web, file, and input activity tracking",
	securityTooltipWebTrack: "Toggle web domain tracking",
	securityTopRiskyDevices: "Top Risky Devices",
	securityTracking: "Tracking",
	securityTrackingEnabledMaster: "Tracking Enabled (master)",
	securityTrackingMasterSwitch: "Tracking Enabled (master switch)",
	securityTrackingOffAlertBody:
		"Activity tracking is explicitly disabled at device level, overriding the policy.",
	securityTrackingOffAlertTitle: "Tracking override: OFF",
	securityTrackingWhenOffDesc: "When off, app, web, file, and input activity tracking are inactive",
	securityUnassigned: "Unassigned",
	securityUnknown: "Unknown",
	securityUnknownDevice: "Unknown device",
	securityUsePolicyDefault: "Use policy default",
	securityUser: "User",
	securityUserLoggedIn: "Logged in",
	securityVideoOffAlertBody:
		"Video recording is explicitly disabled at device level. Alert recordings will not be captured even if the policy enables them.",
	securityVideoOffAlertTitle: "Video override: OFF",
	securityVideoOptionsBlank: "Video recording options (blank = use policy default)",
	securityVideoPlayAllHint:
		"Play all from the selected clip through older segments; when the current page ends, the next page loads and playback continues.",
	securityVideoRecording: "Video Recording",
	securityVideoSegments: "Video Segments",
	securityVideoSegmentsCount: "Video Segments",
	securityViewDetail: "View detail",
	securityWebDomainTracking: "Web Domain Tracking",
	securityWebPollSeconds: "Web history poll (seconds)",
	securityWebTracking: "Web Tracking",
	securityWebsiteVisitsToday: "Website Visits Today",
	securityWhen: "When",
	selectAlbum: "Select Album",
	selectAll: "Select All",
	selectArtist: "Select artist",
	selectBoard: "Select Board",
	selectCategory: "Select category",
	selectChatPartner: "Select chat partner",
	selectClosedDate: "Select closed date",
	selectDate: "Select date",
	selectDays: "Select days",
	selectDomain: "Select Domain",
	selectEmployee: "Select Employee",
	selectFiles: "Select files",
	selectGroup: "Select Group",
	selectOpenedDate: "Select opened date",
	selectParentDepartment: "Select Parent Department",
	selectParentUser: "Select Parent User",
	selectPeriod: "Select period",
	selectPlatformToManageAndNavigate: "Select a platform to manage and navigate",
	selectPlaylist: "Select playlist",
	selectProduct: "Select product",
	selectSomething: "Select something",
	selectUsers: "Select Users",
	selectedSteps: "Selected Steps",
	selectedUsers: "Selected Users",
	seleteSelected: "Select selected",
	send: "Send",
	sent: "Sent",
	seoDesc: "SEO Description",
	servicesAndPrices: "Services and Prices",
	setCostOfBuildingPermit: "Set cost of building permit",
	setDayOff: "Set day off",
	settings: "Settings",
	shiftSchedule: "Shift Schedule",
	showAllSteps: "Show all steps",
	showHistory: "Show history",
	showProjectDetails: "Show project details",
	showTableColumnFilters: "Show column filters",
	showTimeline: "Show timeline",
	showing: "Showing",
	shuffle: "Shuffle",
	shuffleEnabled: "Shuffle Enabled",
	shuffleOverride: "Shuffle override",
	shuffleOverrideDesc: "Shuffle override description",
	shuffleOverrideValue: "Shuffle override value",
	sickLeave: "Sick Leave",
	sickLeaveDays: "Sick Leave Days",
	signIn: "Sign In",
	signUp: "Sign Up",
	size: "Size",
	slider: "Slider",
	small: "Small",
	smb: "Server folder",
	socialAmount: "Social Payment Amount",
	socialCardImages: "Social card images",
	socialCart: "Social Card",
	socialNetworkLink: "Social Network Link",
	socialRate: "Social Payment Rate",
	software: "Software",
	softwareSkills: "Software Skills",
	somethingWentWrong: "Something went wrong",
	somethingWentWrongInCreatingSteps: "Something went wrong in creating steps! Please try again",
	sortBy: "Sort by",
	source: "Source",
	sourceTypeEntity: "From database (entity)",
	sourceTypeManual: "Manual options",
	special: "Special",
	specialItems: "Special Items",
	speed: "Speed",
	starred: "Starred",
	starredMessages: "Starred messages",
	start: "Start",
	startCall: "Start call",
	startDate: "Start Date",
	startDateShort: "Start Date",
	startRecording: "Start recording",
	startTime: "Start time",
	startVideoCall: "Start video call",
	starts: "Starts",
	state: "State",
	states: "States",
	status: "Status",
	visibility: "Visibility",
	statusUpdate: "Status Update",
	stayAnonymous: "Stay anonymous",
	step: "Step",
	stepIsNotStartedYet: "Step is not started yet",
	stepStatus: "Step Status",
	stepStatusChangedByUser: "Step status changed by user",
	steps: "Steps",
	stepsLeft: "Steps Left",
	stillInOffice: "Still in office",
	stockAndProductOverview: "Stock and Product Overview",
	stop: "Stop",
	stopRecording: "Stop recording",
	stopped: "Stopped",
	streamDJ: "Stream DJ",
	streamStatistics: "Stream Statistics",
	streaming: "Streaming",
	streamsWithShuffle: "streams with shuffle enabled",
	street: "Street",
	subDesc: "Sub Description",
	submit: "Submit",
	submittedProjects: "Submitted Projects",
	subscription: "Subscription",
	subscriptions: "Subscriptions",
	substation: "Substation",
	substationNumber: "Substation number",
	subtasks: "Subtasks",
	subtasksPlaceholder: "Enter each subtask on a new line",
	subtitle: "Subtitle",
	success: "Success",
	suffix: "Suffix",
	sun: "Sunday",
	support: "Support",
	supportText: "For all questions write",
	switch: "Switch",
	switchers: "Switchers",
	switches: "Printers",
	syncedFromGoogleContacts: "Synced from Google Contacts",
	systemSettings: "System settings",
	table: "Table",
	tag: "Tag",
	tags: "Tags",
	takeMeHome: "Take Me Home",
	taskCreatedSuccessfully: "Task created successfully",
	taskCreatedSuccessfullyDescription: "Task created successfully",
	taskDescription: "Task Description",
	taskMoved: "Task moved",
	taskMovedDescription: "Task moved from one category to another",
	taskStatusDistribution: "Task Status Distribution",
	taskTitle: "Task Title",
	tasksAssigned: "Tasks Assigned",
	taxCode: "Tax Code",
	taxNote: "Tax note",
	taxes: "Taxes",
	technicalFilesUrl: "Technical Files Url",
	telegram: "Telegram",
	text: "Text",
	theConstructionDepPrice: "The construction department price",
	theNumberOfAct: "The number of act",
	thePriceOfProject: "The price of the project",
	themePickerLabel: "Theme",
	thereIsNoResponsible: "There is no responsible",
	thisMonth: "this month",
	thu: "Thursday",
	ticket: "Ticket",
	ticketClosed: "Ticket closed",
	ticketCreateSaveDisabledHint:
		"Choose domain, problem group (if your setup uses groups), problem, then fill any required related fields before saving.",
	ticketDashboard: "Ticket Dashboard",
	ticketDomain: "Domain",
	ticketDomainsMenu: "Ticket domains",
	ticketHierarchyAddProblem: "Add problem",
	ticketHierarchyAddProblemGroup: "Add problem group",
	ticketHierarchyAddRelatedList: "Add related list",
	ticketHierarchyAddTicket: "Add ticket",
	ticketHierarchyAddTicketDomain: "Add domain",
	ticketHierarchyAddTicketHint: "Opens new ticket create with this domain selected.",
	ticketHierarchyGroupsInDomain: "Problem groups in this domain",
	ticketHierarchyNoneYet: "None yet — use the button above to add one.",
	ticketHierarchyProblemsInGroup: "Problems in this group",
	ticketHierarchyProblemsLinkedToList: "Problems using this related list",
	ticketRelatedLists: "Related lists",
	ticketRelatedListsMenu: "Related list definitions",
	ticketSystemOverview: "Overview of ticket system performance and metrics",
	ticketTitle: "Title",
	ticketType: "Type",
	ticketTypeDomainsHint:
		"Leave empty to make this type available in every domain. Select one or more domains to list it only there.",
	ticketTypeDomainsListAll: "All domains",
	ticketFieldVisibility: "Ticket Field Visibility",
	ticketWorkflow: "Ticket workflow",
	ticketNoResponsibleUsers: "No responsible users",
	ticketSteps: "Ticket steps",
	ticketStepsRequired: "At least one ticket step is required.",
	ticketStepTitle: "Step title",
	ticketStepTitleRequired: "Step title is required.",
	ticketStepResponsibleRequired: "Select at least one responsible user.",
	ticketResponsibleMode: "Responsible mode",
	ticketResponsibleUsers: "Specific users",
	ticketResponsibleOpenerSupervisor: "Opening user's immediate supervisor",
	responsibleUsers: "Responsible users",
	ticketReminderLeadMinutes: "Reminder lead time (minutes)",
	ticketReminderLeadMinutesPlaceholder: "Minutes before deadline",
	deadlineTime: "Deadline time",
	remindBefore: "Remind before",
	ticketAutoClose: "Auto-close",
	ticketAutoCloseAfter: "Auto-close after",
	ticketAutoCloseAfterHours: "Auto-close resolved tickets after hours",
	ticketAutoCloseAfterHoursHint: "Use 0 to disable automatic closing of resolved tickets.",
	ticketSettingsLoadFailed: "Could not load ticket settings",
	ticketSettingsPageSubtitle: "Control global ticket workflow defaults.",
	ticketSettingsPageTitle: "Ticket Settings",
	ticketSettingsReadOnly: "You can view this setting, but only ticket admins can change it.",
	ticketSettingsSaveFailed: "Could not save ticket settings",
	ticketSettingsSaved: "Ticket settings saved",
	ticketStatus_sent: "Sent",
	ticketStatus_in_process: "In process",
	ticketStatus_resolved_rejected: "Resolved rejected",
	ticketStatus_resolved_approved: "Resolved approved",
	ticketStatus_moved_next: "Moved next",
	ticketStatus_moved_prev: "Moved previous",
	ticketStatus_closed: "Closed",
	ticketStatus_not_accepted: "Not accepted",
	ticketAction_start: "Start process",
	ticketAction_next: "Next step",
	ticketAction_prev: "Previous step",
	ticketAction_approve: "Approve",
	ticketAction_reject: "Reject",
	ticketAction_close: "Close ticket",
	ticketAction_cancel: "Cancel ticket",
	ticketAction_comment: "Comment",
	cancelTicket: "Cancel ticket",
	ticketCancelReason: "Cancellation reason",
	ticketCancelComment: "Additional comment",
	ticketCancelCommentPlaceholder: "Add details for the opener if needed",
	ticketCancelWarning:
		"This ticket will be marked as not accepted and closed. The opener must create a new ticket if they still need help.",
	ticketNotAccepted: "Ticket not accepted",
	ticketStepStatus_pending: "Pending",
	ticketStepStatus_active: "Active",
	ticketStepStatus_completed: "Completed",
	ticketStepStatus_approved: "Approved",
	ticketStepStatus_rejected: "Rejected",
	ticketStepStatus_closed: "Closed",
	ticketStepStatus_cancelled: "Cancelled",
	dateMode: "Date mode",
	dateModesSingle: "Single date",
	dateModesInterval: "Date interval",
	tickets: "Tickets",
	ticketsByDepartment: "Tickets by Department",
	ticketsByImportance: "Tickets by Priority",
	ticketsByProblem: "Tickets by Problem Type",
	ticketsByStatus: "Tickets by Status",
	ticketsOverTime: "Tickets Over Time",
	timAgreement: "TIM agreement",
	timDelays: "TIM delays",
	timSentProjects: "TIM Sent Projects",
	time: "Time",
	timeBasedScheduling: "Time-based scheduling",
	timeOff: "Time Off",
	timeRange: "Time Range",
	timeToClose: "time to close ticket",
	timeToFirstResponse: "time to first response",
	timeline: "Timeline",
	timestamp: "Timestamp",
	timezone: "Timezone",
	title: "Title",
	to: "To",
	toChat: "To chat",
	toDo: "To Do",
	today: "Today",
	todaysSales: "Today's Sales",
	todo: "Todo",
	todoBoard: "Board",
	todoBoards: "Boards",
	todoCategories: "Categories",
	todoCategory: "Category",
	todoLabel: "Label",
	todoLabels: "Labels",
	todoTag: "Tag",
	todoTags: "Tags",
	todoTask: "Task",
	todoTasks: "Tasks",
	toggles: "Toggles",
	top: "Top",
	topCustomers: "Top Customers",
	topProducts: "Top Products",
	total: "Total",
	totalActiveTasks: "Total active tasks",
	totalArtists: "Total Artists",
	totalChats: "Total Chats",
	totalContacts: "Total Contacts",
	totalCoins: "Total Coins",
	totalContent: "Total Content",
	totalCustomers: "Total Customers",
	totalDeductions: "Total Deductions",
	totalDuration: "Total Duration",
	totalGroups: "total groups",
	totalHours: "Total Hours",
	missingDays: "Missing Days",
	missingHours: "Missing Hours",
	scheduled: "Scheduled",
	totalHoursWorked: "Total hours worked",
	totalInTrash: "Total in trash",
	totalMessages: "Total Messages",
	totalOTHours: "Total OT Hours",
	totalOrders: "Total Orders",
	totalOvertime: "Total Overtime",
	totalPlaylists: "Total Playlists",
	totalPrice: "Total price",
	totalProducts: "Total Products",
	totalRevenue: "Total Revenue",
	totalTickets: "Total Tickets",
	totalTracks: "Total Tracks",
	totalUses: "Total Uses",
	totalValue: "Total Value",
	track: "Track",
	trackPlaylist: "Track playlist",
	tracks: "Tracks",
	tracksByArtist: "Tracks by Artist",
	transportAllowance: "Transport Allowance",
	trash: "Trash",
	trashAutoDeleteWarning: "Trash auto delete warning",
	trashEmptied: "Trash emptied",
	trashedOn: "Trashed on",
	tryAgain: "Try Again",
	tue: "Tuesday",
	type: "Type",
	uncoveredInterval: "Uncovered interval",
	undefined: "Undefined",
	undo: "Undo",
	university: "University",
	universityDegree: "University Degree",
	universityDepartment: "University Department",
	unjustifiedAbsence: "Unjustified absence",
	unknown: "Unknown",
	unknownArtist: "Unknown Artist",
	unnamed: "Unnamed",
	unnamedContact: "Unnamed Contact",
	unnamedTrack: "Unnamed Track",
	unpaid: "Unpaid",
	unreadMessages: "Unread Messages",
	unresolvedMissingIntervals: "Unresolved missing intervals — payroll may be inaccurate",
	upcomingBirthdays: "Upcoming Birthdays",
	update: "Update",
	updatedAt: "Updated At",
	updates: "Updates",
	upload: "Upload",
	uploadDate: "Upload Date",
	cancelUpload: "Cancel upload",
	uploadCancelled: "Upload cancelled",
	uploadCancelledMessage: "The upload was stopped.",
	uploading: "Uploading",
	uploads: "Uploads",
	uptime: "Uptime",
	urgent: "Urgent",
	used: "Used",
	usedCount: "Used count",
	usedVacation: "Used vacation",
	user: "User",
	userArchive: "User Archive",
	userDashboard: "User Dashboard",
	myPage: "My Page",
	userDeleted: "Deleted",
	userEntered: "User entered",
	userProfile: "User Profile",
	userPageAccrued: "Accrued",
	userPageAvailableVacationDays: "Available vacation days",
	userPageCurrentBalance: "Current balance",
	userPageDays: "days",
	userPageNote: "Note",
	userPagePayroll: "Payroll",
	userPayrollSubtitle:
		"Configure interval salary input, calculate gross and net payroll, and record actual payment events.",
	userPayrollGross: "Gross payroll",
	userPayrollNetPayable: "Net payable",
	userPayrollAlreadyPaid: "Already paid",
	userPayrollRemaining: "Remaining",
	userPayrollBasis: "Payroll basis",
	userPayrollFixedMonthly: "Fixed monthly",
	userPayrollHourly: "Hourly",
	userPayrollPerTask: "Per task",
	userPayrollFixedSalary: "Fixed salary",
	userPayrollCalcUsesAttendance:
		"This calculation uses the canonical attendance and leave summary for {monthKey}, then applies the active tax rules from HR Settings.",
	userPayrollAttendanceLeaveImpact: "Attendance and leave impact",
	userPayrollWorkedTime: "Worked time",
	userPayrollOvertime: "Overtime",
	userPayrollLeaveCoveredTime: "Leave-covered time",
	userPayrollVacationAccrued: "Vacation accrued",
	userPayrollVacationBalance: "Vacation balance",
	userPayrollMissingUncovered: "Missing / uncovered",
	userPayrollTaxBreakdown: "Tax breakdown",
	userPayrollTax: "Tax",
	userPayrollRate: "Rate",
	userPayrollAmount: "Amount",
	userPayrollNoTaxLines: "No tax lines were generated for this period.",
	userPayrollRecordPayment: "Record payroll payment",
	userPayrollRemainingBadge: "Remaining {amount}",
	userPayrollCalculateFirst: "Calculate payroll first",
	userPayrollTotalPaid: "Total paid",
	userPayrollCashAmount: "Cash amount",
	userPayrollTransferAmount: "Transfer amount",
	userPayrollSavePaymentEvent: "Save payment event",
	userPayrollPaymentHistory: "Payment history",
	userPayrollDate: "Date",
	userPayrollPaid: "Paid",
	userPayrollCash: "Cash",
	userPayrollTransfer: "Transfer",
	userPayrollBy: "By",
	userPayrollNoPaymentEvents: "No payroll payment events recorded for this period yet.",
	userPayrollAuditLog: "Payroll audit log",
	userPayrollAllHistory: "All payroll history",
	userPayrollGrossShort: "Gross",
	userPayrollNetShort: "Net",
	userPayrollPaidShort: "Paid",
	userPayrollStatus: "Status",
	userPayrollActions: "Actions",
	userPayrollNoRecords: "No payroll records found for this employee.",
	userPayrollCalculatedTitle: "Payroll calculated",
	userPayrollCalculatedMessage:
		"The payroll snapshot has been refreshed from attendance, leave, and tax settings.",
	userPayrollCalcFailedTitle: "Payroll calculation failed",
	userPayrollPaymentRecordedTitle: "Payment recorded",
	userPayrollPaymentRecordedMessage:
		"The payroll payment event was saved and reflected in finance reporting.",
	userPayrollPaymentFailedTitle: "Payment failed",
	userPayrollSelectMonth: "Select month",
	userPageSecurity: "Security",
	userPageSetRemainingVacationDays: "Set the remaining vacation days for this user.",
	userPageUsed: "Used",
	userUpdated: "Updated",
	userVisited: "User visited",
	username: "Username",
	users: "Human Resources",
	vacationBalance: "Vacation balance",
	vacationDaysForPeriod: "Vacation days for selected period",
	vacationInterval: "Vacation interval",
	vacationPay: "Vacation Pay",
	value: "Value",
	version: "Version",
	viber: "Viber",
	video: "Video",
	view: "View",
	viewAll: "View All",
	viewDetails: "View Details",
	viewMore: "View More",
	viewProject: "View project",
	viewSteps: "View steps",
	viewTrash: "View Trash",
	village: "Village",
	villages: "Village list",
	visitation: "Visitation",
	visitationDeadline: "Visitation Dead Line",
	visitationDelays: "Visitation delays",
	voltage: "Voltage",
	voltageLevel: "Voltage level",
	volumes: "Volumes",
	voluntaryPensionAmount: "Voluntary Pension Amount",
	voluntaryPensionRate: "Voluntary Pension Rate (%)",
	vsPreviousPeriod: "vs Previous Period",
	warning: "Warning",
	warrantyDate: "Warranty date",
	warrantyDesc: "Warranty description",
	warrantyEnd: "Warranty end",
	warrantyProvider: "Warranty provider",
	warrantyStart: "Warranty start",
	watchers: "Watchers",
	weatherAriaYerevanForecast: "Yerevan weather forecast",
	weatherCityYerevan: "Yerevan",
	weatherClear: "Clear",
	weatherCloudy: "Cloudy",
	weatherDrizzle: "Drizzle",
	weatherFog: "Fog",
	weatherForecastUnavailable: "Forecast unavailable",
	weatherHeadingYerevan: "Yerevan weather",
	weatherHumidity: "Humidity",
	weatherLoadingShort: "Weather",
	weatherNextHours: "Next hours",
	weatherPartlyCloudy: "Partly cloudy",
	weatherPrecipUnit: "mm",
	weatherRain: "Rain",
	weatherSnow: "Snow",
	weatherTempUnit: "°C",
	weatherThunderstorm: "Thunderstorm",
	weatherUnknown: "Forecast",
	weatherWind: "Wind",
	weatherWindUnit: "km/h",
	wed: "Wednesday",
	weekly: "Weekly",
	whatToDo: "What to do",
	whatToDoLink: "What to do",
	whatsapp: "WhatsApp",
	withAttachments: "With Attachments",
	withCoins: "With Coins",
	withFavorites: "With Favorites",
	workDays: "Work Days",
	workInformation: "Work information",
	workTime: "Work Time",
	workedDays: "Worked Days",
	workedHours: "Worked hours",
	working: "Working",
	workingDays: "Working Days",
	workingHoursByDay: "Working Hours by Day",
	workingMinutes: "Working Minutes",
	workingState: "Working state",
	workingStatus: "Working Status",
	write: "Write",
	writeUsIfThereAreAnyQuestions: "Write us if there are any questions",
	writingContent: "Writing content",
	writingNumber: "Writing number",
	yes: "Yes",
	yesNextStep: "Yes, go to the next step",
	yesPreviousStep: "Yes, go to the previous step",
	youCannotRevertThisAction: "You cannot revert this action!",
	youWontBeAbleToRevert: "You won't be able to revert this!",
	yourFileHasBeenDeleted: "Your file has been deleted.",
	yourFileHasBeenNotSaved: "Your file has not been saved.",
	yourFileHasBeenSaved: "Your file has been saved.",
	zipCode: "Zip Code",
	zipCodes: "Zip Codes",
	vacationIntervalNoDeduction: "Vacation is not deducted on non-working days",
	knowledgeDashboardLoadFailed: "Failed to load dashboard",
	knowledgeArticlesLoadFailed: "Failed to load articles",
	knowledgeBase: "Knowledge Base",
	knowledgeCreate: "Create",
	knowledgeRunAutoDocs: "Run Auto Docs",
	knowledgeTotalArticles: "Total articles",
	knowledgePublished: "Published",
	knowledgeDrafts: "Drafts",
	knowledgeAutoGenerated: "Auto-generated",
	knowledgeLatestUpdatedArticles: "Latest Updated Articles",
	knowledgeArticles: "Articles",
	knowledgeNewArticle: "New Article",
	knowledgeFilterArticles: "Filter articles",
	knowledgeCategories: "Categories",
	knowledgeParentCategory: "Parent category",
	knowledgeIcon: "Icon",
	knowledgeColor: "Color",
	knowledgeSortOrder: "Sort order",
	knowledgeCategorySaved: "Category saved",
	knowledgeCategoryDeleted: "Category deleted",
	knowledgeSearch: "Search",
	knowledgeSearchArticles: "Search articles",
	knowledgePath: "Path",
	knowledgeAutoGeneratedDocs: "Auto Generated Docs",
	knowledgeSingleRoute: "Single route",
	knowledgeNoScreenshots: "No screenshots",
	knowledgeGenerateDocumentation: "Generate Documentation",
	knowledgeImportGeneratedDocs: "Import Generated Docs",
	knowledgeDocumentationGenerationStarted: "Documentation generation started",
	knowledgeImported: "Imported",
	knowledgeGeneratedDocsImported: "{count} generated docs imported",
	knowledgeStarted: "Started",
	knowledgeFinished: "Finished",
	knowledgeRun: "Run",
	knowledgeOutput: "Output",
	knowledgeStatus_draft: "Draft",
	knowledgeStatus_published: "Published",
	knowledgeStatus_archived: "Archived",
	knowledgeVisibility_public: "Public",
	knowledgeVisibility_private: "Private",
	knowledgeVisibility_company: "Company",
	knowledgeRunStatus_idle: "idle",
	knowledgeRunStatus_running: "running",
	knowledgeRunStatus_completed: "completed",
	knowledgeRunStatus_failed: "failed",
	meetings: "Meetings",
	meetingsListSubtitle: "Scheduled rooms with APIT chat and calendar attached.",
	meetingsCreateMeeting: "Create meeting",
	meetingsEditMeeting: "Edit meeting",
	meetingsCreateSubtitle: "Meeting = calendar event + chat group + video room.",
	meetingsMeetingType: "Meeting type",
	meetingsDate: "Date",
	meetingsStartTime: "Start time",
	meetingsEndTime: "End time",
	meetingsTimezone: "Timezone",
	meetingsVisibility: "Visibility",
	meetingsParticipants: "Participants",
	meetingsGroupsDepartments: "Groups/departments",
	meetingsOptionalGroupIds: "Optional group ids",
	meetingsLocation: "Location",
	meetingsReminderTime: "Reminder time",
	meetingsMinutesShort: "min",
	meetingsAgenda: "Agenda",
	meetingsAgendaPlaceholder: "Kickoff\nDesign review\nNext steps",
	meetingsRecordingEnabled: "Recording enabled",
	meetingsAllowJoinBeforeHost: "Allow join before host",
	meetingsMuteUsersOnEntry: "Mute users on entry",
	meetingsAllowScreenSharing: "Allow screen sharing",
	meetingsSaveAsDraft: "Save as draft",
	meetingsSaveMeeting: "Save meeting",
	meetingsCreateAndNotifyUsers: "Create and notify users",
	meetingsSaved: "Meeting saved",
	meetingsSaveFailed: "Could not save meeting",
	meetingsJoin: "Join",
	meetingsOpenChat: "Open chat",
	meetingsParticipantsCount: "{count} participants",
	meetingsType_video: "Video",
	meetingsType_audio: "Audio",
	meetingsType_in_person: "In person",
	meetingsType_hybrid: "Hybrid",
	meetingsVisibility_private: "Private",
	meetingsVisibility_company: "Company",
	meetingsVisibility_department: "Department",
	meetingsStatus_draft: "Draft",
	meetingsStatus_scheduled: "Scheduled",
	meetingsStatus_live: "Live",
	meetingsStatus_ended: "Ended",
	meetingsStatus_cancelled: "Cancelled",
	aiSettingsAction: "Action",
	aiSettingsAllowedModules: "Allowed modules",
	aiSettingsApprove: "Approve",
	aiSettingsApprovalFailed: "Approval failed",
	aiSettingsDisabled: "Disabled",
	aiSettingsEnabled: "Enabled",
	aiSettingsEvent: "Event",
	aiSettingsLogs: "Logs",
	aiSettingsLoadFailed: "Failed to load AI settings",
	aiSettingsNoGateway: "No gateway configured",
	aiSettingsNoPendingApprovals: "No pending approvals",
	aiSettingsNoLogs: "No logs",
	aiSettingsNoPermission: "Missing AI admin permission.",
	aiSettingsPendingApprovals: "Pending approvals",
	aiSettingsReject: "Reject",
	aiSettingsRejectFailed: "Reject failed",
	aiSettingsRefresh: "Refresh",
	aiSettingsRequireApproval: "Require approval",
	aiSettingsStatus: "Status",
	aiSettingsTime: "Time",
	aiSettingsTitle: "AI Settings",
	aiSettingsTool: "Tool",
	aiSettingsUser: "User",
	aiSettingsUpdateFailed: "Settings update failed",
	aiSettingsDefaultMode: "Default mode",
	aiSettingsReadOnly: "read_only",
	aiSettingsApprovalRequired: "approval_required",
	aiSettingsAdminOnly: "admin_only",
	financeActiveCurrencies: "{count} active currencies",
	financeAddCurrency: "Add currency",
	financeCurrencyCode: "Code",
	financeCurrencyCoefficient: "Coefficient",
	financeCurrencyDefault: "Default",
	financeCurrencyName: "Name",
	financeCurrencySymbol: "Symbol",
	financeCurrencyUse: "Use",
	financeLoadFailed: "Could not load finance settings",
	financeSaveSettings: "Save settings",
	financeSavedMessage: "Finance settings saved",
	financeSaveFailed: "Could not save finance settings",
	financeSelectedDefault: "Selected default:",
	financeSettingsSubtitle:
		"Currencies here control the default money display across finance and order pages.",
	financeSettingsTitle: "Finance Settings",
	hrAccrualCoeffPreview: "Coefficient preview",
	hrAccrualCoeffPreviewLine1:
		"{accrualWorkedHours} worked hours → {accrualVacationHours} vacation hours",
	hrAccrualCoeffPreviewLine2: "Vacation hours earned per worked hour: {hourlyCoefficient}",
	hrAccrualCoeffStoredNote:
		"The backend stores this accrual in minutes so payroll and leave balances can use partial-day values without rounding drift.",
	hrAccrualFixedYearly: "Fixed yearly vacation days",
	hrAccrualFixedYearlyDesc:
		"Accrue a configured number of vacation days across the year using the existing daily or monthly schedule.",
	hrAccrualModelChoice:
		"Choose one active accrual model. Yearly days and worked-hours coefficient are OR logic, not combined.",
	hrAccrualSuffixMin: "min",
	hrAccrualVacationMinutesEarned: "Vacation minutes earned",
	hrAccrualVacationMinutesEarnedDesc:
		"How many vacation minutes are accrued for each worked-time unit.",
	hrAccrualWorkBreak: "Work break",
	hrAccrualWorkBreakDesc:
		"Daily uncovered minutes to classify as breaks in missing-from-office intervals.",
	hrAccrualWorkedHoursModel: "Worked hours to vacation hours",
	hrAccrualWorkedHoursModelDesc:
		"Accrue vacation from actual worked time using a configurable worked-hours coefficient.",
	hrAccrualWorkedMinutesUnit: "Worked minutes unit",
	hrAccrualWorkedMinutesUnitDesc: "How many worked minutes should generate one accrual unit.",
	hrWeekdayFri: "Fri",
	hrWeekdayMon: "Mon",
	hrWeekdaySat: "Sat",
	hrWeekdaySun: "Sun",
	hrWeekdayThu: "Thu",
	hrWeekdayTue: "Tue",
	hrWeekdayWed: "Wed",
	knowledgeSettingsAiEnabled: "AI enabled",
	knowledgeSettingsAiModel: "AI model",
	knowledgeSettingsAiProvider: "AI provider",
	knowledgeSettingsEnableAutoDocs: "Enable auto docs",
	knowledgeSettingsLanguage: "Default language",
	knowledgeSettingsMaxSizeMb: "Max article size MB",
	knowledgeSettingsRootCategory: "Auto docs root category",
	knowledgeSettingsSaveSettings: "Save Settings",
	knowledgeSettingsSaved: "Knowledge settings updated",
	knowledgeSettingsTitle: "Settings",
	knowledgeSettingsUploadExt: "Allowed upload extensions",
	knowledgeSettingsVisibility: "Default visibility",
	nvrAddFromList: "Add cameras from list",
	nvrCamerasList: "Cameras list",
	nvrChannel: "Channel",
	nvrChannelId: "ID",
	nvrChannelName: "Name",
	nvrChannelsTitle: "Channels registered from this NVR",
	nvrConnectionDesc:
		"Enter IP, port, and the path template (only /.../\\{channel\\}... — same as in VLC, without the rtsp:// part). Add RTSP username and password (most NVRs need them). Click Save to run an automatic network scan, or use Add cameras from paths below to register channels without a scan. Open a camera for live view; on the office map, place devices as usual.",
	nvrConnectionTitle: "NVR — one connection for all channels",
	nvrDiscoveryFailed: "Discovery failed",
	nvrEnterPaths: "Enter at least one channel or path.",
	nvrFoundChannels: "Found {n} channel(s).",
	nvrFullUrl: "Full URL (channel 101 — auto from fields above)",
	nvrInitError: "NVR could not be initialized. Reload the page.",
	nvrIp: "NVR IP",
	nvrIpPasswordRequired:
		"NVR IP and a saved password are required. Set the password, save, and we will scan for channels on the next save.",
	nvrLoadFailed: "Failed to load NVR",
	nvrLiveStatus: "Live Status",
	nvrManualDesc:
		"When automatic scanning fails (e.g. API cannot reach the NVR), list channels here. Use one per line: channel numbers like 101, 201, a path like /Streaming/Channels/102, or a full rtsp:// URL. Paths are combined with your RTSP path template when you enter numbers only. Save the NVR first if you changed IP or template, then add rows and click the button.",
	nvrManualTitle: "Add cameras from RTSP paths (no server scan)",
	nvrNotReady: "NVR is not ready. Reload the page.",
	nvrNotReadyShort: "NVR is not ready.",
	nvrNotWorking: "Not working",
	nvrOfficeMap: "Office map",
	nvrOffline: "Offline",
	nvrOnline: "Online",
	nvrPasswordChangeNote: "Change and save to update the stored password.",
	nvrPasswordLeaveBlank: "Leave blank to keep the current password",
	nvrPasswordRequired: "Required for most NVRs to discover channels and to stream.",
	nvrPasswordStoredLeaveBlank: "Password is stored; leave blank to keep it, or type a new one.",
	nvrRegisterFailed: "Could not register paths",
	nvrRegisteredCameras: "Registered {n} camera(s).",
	nvrRtspPassword: "RTSP password",
	nvrRtspPathTemplate: "RTSP path template",
	nvrRtspPathTemplateHint:
		"Type only the path with {channel}. Do not enter the full rtsp:// string here.",
	nvrRtspUsername: "RTSP username",
	nvrScanChannels: "Scan channels again",
	nvrScanHint: "This saves the current connection fields, then scans.",
	nvrWorkingState: "Working state",
	nvrWorking: "Working",
	nvrGridEmpty: "No channels linked to this NVR yet. Run discovery on the NVR page.",
	nvrGridLoadFailed: "Failed to load channels",
	nvrGridLoading: "Loading channels…",
	nvrGridStreamFailed: "Failed to start",
	nvrGridStreamStopped: "Stream stopped",
	nvrGridTitle: "All NVR channels",
	securityRecordingActiveDays: "Active days",
	securityRecordingDesc:
		"Enable server-side recording for cameras that have Record on server turned on. Each camera can also have its own schedule below.",
	securityRecordingEndTime: "End time",
	securityRecordingGlobalEnable: "Enable recording globally",
	securityRecordingGlobalEnableDesc:
		"Master switch — disabling this stops all recording regardless of per-camera settings.",
	securityRecordingLoadFailed: "Failed to load security settings",
	securityRecordingLocalFs: "Local filesystem",
	securityRecordingLocalPathNote:
		"Local path is configured via the SECURITY_RECORDING_LOCAL_PATH environment variable on the server.",
	securityRecordingNoScheduleNote:
		"No schedule — cameras will record 24/7 when Record on server is enabled.",
	securityRecordingRetentionDays: "Retention (days)",
	securityRecordingRetentionDesc: "Segments older than this are deleted automatically.",
	securityRecordingS3: "S3 / compatible object storage",
	securityRecordingS3Note:
		"S3 credentials are configured via environment variables on the server (AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, etc.).",
	securityRecordingSaveSettings: "Save settings",
	securityRecordingSaved: "Security settings saved.",
	securityRecordingSaveFailed: "Failed to save settings",
	securityRecordingScheduleDesc:
		"This schedule applies to all cameras with Record on server enabled that do not have their own per-camera schedule override.",
	securityRecordingScheduleEnable: "Enable default schedule (record only during set hours)",
	securityRecordingScheduleNote:
		"Recording will run on the selected days between these hours. Outside this window, recording is paused automatically.",
	securityRecordingScheduleTitle: "Default recording schedule",
	securityRecordingSegmentLength: "Segment length (minutes)",
	securityRecordingSegmentLengthDesc:
		"This controls how often a new video appears on each camera page.",
	securityRecordingStartTime: "Start time",
	securityRecordingStorage: "Storage",
	securityRecordingStorageBackend: "Storage backend",
	securityRecordingTitle: "Camera recording on server",
	securitySurveillanceCameraMedia: "Camera media",
	securitySurveillanceDashboard: "Surveillance Dashboard",
	securitySurveillanceNoCameras: "No cameras found.",
	securitySurveillanceOffline: "Offline",
	securitySurveillanceOnline: "Online",
	teamWorkload: "Team workload",
	workloadTasks: "Tasks",
	workloadTickets: "Tickets",
	workloadSteps: "Steps",
	noOpenWorkload: "No open workload",
	flexCardTotal: "Flex cards",
	attendanceCards: "Attendance cards",
	flexCardTotalSubtitle: "Assigned or ignored Flex IDs",
	flexCardsAttached: "Attached",
	flexCardsAttachedSubtitle: "Unique IDs attached to users",
	flexCardsIgnored: "Ignored",
	flexCardsIgnoredSubtitle: "Ignored in HR settings",
	flexCardsDuplicateAttached: "Duplicate attached",
	flexCardIds: "card IDs",
	noDuplicateFlexCards: "No duplicates",
	duplicate: "Duplicate",
	duplicateFlexId: "Duplicate Flex ID",
	flexIdDuplicateWarning: "Also assigned to",
	anotherUser: "another user",
	attendanceTable: "Attendance Table",
	filteredFrom: "filtered from",
	weekend: "Weekend",
	attendanceNextRefresh: "Next refresh",
	refreshAttendanceDevices: "Refresh data from attendance devices",
	attendanceSyncSuccess: "Attendance devices synchronized",
	attendanceSyncFailed: "Attendance device synchronization failed",
	// User account security / profile
	contactInformation: "Contact information",
	accountSecurity: "Account security",
	accountStatus: "Account status",
	accountStatusActive: "Active",
	accountStatusLocked: "Locked",
	mustChangePassword: "Must change password",
	lockedAt: "Locked at",
	passwordLastChanged: "Password last changed",
	accountSecurityDesc: "Current passwords are never visible. Use a temporary password or a secure reset link when credentials must change.",
	accountSecurityHint: "Use Reset password when you need an immediate credential rotation. Use Send reset link when the user should choose a new password without the admin seeing any secret.",
	lockAccount: "Lock account",
	unlockAccount: "Unlock account",
	forcePasswordChangeAction: "Force password change",
	clearForcedPasswordChange: "Clear forced password change",
	resetPassword: "Reset password",
	sendResetLink: "Send reset link",
	sessionVisibilityRequiresPermission: "Session and device visibility requires additional permission.",
	resetPasswordConfirmTitle: "Reset this password?",
	resetPasswordConfirmText: "A temporary password will be generated and the user will have to change it on the next login.",
	temporaryPasswordGenerated: "Temporary password generated",
	temporaryPasswordShareHint: "Share this only through a secure channel.",
	sendResetLinkConfirmTitle: "Send password reset link?",
	sendResetLinkConfirmText: "A secure, single-use password reset link will be emailed to this user.",
	passwordResetLinkSent: "Password reset link sent.",
	lockAccountConfirmTitle: "Lock this account?",
	unlockAccountConfirmTitle: "Unlock this account?",
	lockAccountConfirmText: "User will be unable to sign in until unlocked.",
	unlockAccountConfirmText: "The user will be able to sign in again immediately.",
	accountLockedMsg: "Account locked.",
	accountUnlockedMsg: "Account unlocked.",
	forcePasswordChangeConfirmTitle: "Force password change on next login?",
	removeForcedPasswordChangeConfirmTitle: "Remove forced password change?",
	forcePasswordChangeConfirmText: "The user will be allowed to sign in only to complete a password change before using the platform.",
	removeForcedPasswordChangeConfirmText: "The user will be allowed to continue signing in normally.",
	forcedPasswordChangeEnabled: "Forced password change enabled.",
	forcedPasswordChangeRemoved: "Forced password change removed.",
	securityUpdated: "Security updated",
	securityActionFailed: "Security action failed",
	knownDevicesAndSessions: "Known devices and open sessions",
	knownDevicesAndSessionsDesc: "Locations are approximate and usually represent an IP origin, ISP, VPN egress, or office gateway rather than the exact physical device position.",
	openSessionsBadge: "{count} open",
	revokeOtherSessions: "Revoke other sessions",
	registeredDevices: "Registered devices",
	unknownDevice: "Unknown device",
	unknownBrowser: "Unknown browser",
	unknownOs: "Unknown OS",
	browserOnOs: "{browser} on {os}",
	firstSeen: "First seen",
	sessionsBadge: "{count} sessions",
	currentDevice: "Current device",
	noKnownDevices: "No known devices recorded yet.",
	approximateLoginOrigins: "Approximate login origins",
	sessionDetails: "Session details",
	device: "Device",
	network: "Network",
	lastActive: "Last active",
	approximateLocationUnavailable: "Approximate location unavailable",
	revoke: "Revoke",
	noAuthSessions: "No auth sessions recorded yet.",
	sessionOriginApproximateNote: "Session origin data is approximate. Do not treat IP geolocation as exact device position.",
	connectedMeansNote: "Connected means the browser/app still has a live socket. Disconnected means the browser was closed or went offline, but the saved sign-in session may still be valid until logout, revoke, or expiry.",
	revokeThisSessionTitle: "Revoke this session?",
	revokeThisSessionText: "The selected device/session will be forced to sign in again.",
	revokeSession: "Revoke session",
	sessionRevoked: "Session revoked",
	sessionRevokedSuccess: "The selected session was revoked successfully.",
	failedToRevokeSession: "Failed to revoke session",
	unableToRevokeSession: "Unable to revoke the selected session.",
	revokeOtherSessionsTitle: "Revoke other sessions?",
	revokeOtherSessionsText: "All sessions for this user will be revoked except the current session when the user is revoking their own devices.",
	revokeSessions: "Revoke sessions",
	sessionsRevoked: "Sessions revoked",
	revokedSessionsCount: "Revoked {count} sessions.",
	failedToRevokeSessions: "Failed to revoke sessions",
	unableToRevokeSessions: "Unable to revoke the selected sessions.",
	failedToLoadSessions: "Failed to load sessions",
	unableToLoadUserSessions: "Unable to load user sessions.",
	sessionStatusRevoked: "Revoked",
	sessionStatusConnected: "Connected",
	sessionStatusDisconnected: "Disconnected",
	currentSession: "Current",
	passwordChangeOnly: "Password change only",
	faceId: "Face ID",
	passwordsNeverShownHint: "Passwords are never shown here. Use the Security tab to lock or unlock this account, force a password change, generate a temporary password, or send a secure reset link.",
	sharedFolders: "Shared folders",
	flexId: "Flex Id",
	emailNotProvided: "Email not provided",
	anonymousUser: "Anonymous User",
	noMapPointsYet: "No map points yet",
	noMapPointsYetDesc: "No session locations with approximate coordinates are available yet. The backend can still track devices and sessions without a geo provider.",
	googleMapsKeyNotConfigured: "Google Maps key not configured",
	googleMapsKeyNotConfiguredDesc: "Set REACT_APP_GOOGLE_MAPS_API_KEY to render the approximate session map.",
	mapFailedToLoad: "Map failed to load",
	mapFailedToLoadDesc: "Unable to load Google Maps right now.",
	approximateLocation: "Approximate location",
	officeInventory: "Office Inventory",
	officeInventoryDescription: "Track non-IT assets and supplies the company already owns.",
	infrastructure: "Infrastructure",
	inventory: "Inventory",
	fixedAssets: "Fixed Assets",
	consumables: "Consumables",
	storageStock: "Storage / Stock",
	maintenance: "Maintenance",
	reservations: "Reservations",
	receivePurchase: "Receive Purchase",
	responsiblePerson: "Responsible Person",
	storageLocation: "Storage Location",
	lowStock: "Low Stock",
	expiringSoon: "Expiring Soon",
	underMaintenance: "Under Maintenance",
	assetNumber: "Asset Number",
	inventoryTransaction: "Inventory Transaction",
	allItems: "All Items",
	addItem: "Add item",
	importExcel: "Import Excel",
	exportExcel: "Export Excel",
	printQrLabels: "Print QR labels",
	advancedFilters: "Advanced filters",
	recentlyReceived: "Recently Received",
	unassigned: "Unassigned",
	damaged: "Damaged",
	inventoryType: "Inventory type",
	availableQuantity: "Available quantity",
	condition: "Condition",
	location: "Location",
	noInventoryItems: "No inventory items found",
	inventoryEmptyDesc: "Add an owned item manually or receive an approved Office purchase.",
	productPurpose: "Product purpose / Usage context",
	generalProduct: "General product",
	officeInventoryProduct: "Office inventory",
	itAssetProduct: "IT asset",
	serviceProduct: "Service",
	officeClassification: "Office classification",
	inventoryCreationRules: "Inventory creation rules",
	defaultDestination: "Default destination",
	trackingMode: "Tracking mode",
	individuallyTracked: "Individually tracked",
	batchTracked: "Batch tracked",
	autoCreateOnReceipt: "Create inventory automatically after purchase receipt",
	autoGenerateAssetNumber: "Generate asset number automatically",
	autoGenerateQrCode: "Generate QR code automatically",
	requireSerialNumber: "Require serial number",
	requireWarranty: "Require warranty information",
	requireExpirationDate: "Require expiration date",
	requireInspection: "Require inspection schedule",
	canBecomeBookable: "Can become a bookable resource",
	totalActiveRooms: "Total Active Rooms",
	bookingsToday: "Bookings Today",
	activeNow: "Active Now",
	pendingApprovals: "Pending Approvals",
	officeMaintenanceDescription: "Office inventory repairs, inspections, and scheduled maintenance.",
	noMaintenanceRecords: "No maintenance records found.",
	settingsDescription: "Configure categories, numbering, warnings, and storage locations without hardcoding business values.",
	rulesNumbering: "Rules & numbering",
	requirements: "Requirements",
	assetNumberFormat: "Asset number format",
	assetNumberTokens: "Tokens: {YEAR}, {SEQUENCE}, {OFFICE_CODE}, {CATEGORY_CODE}",
	qrValueFormat: "QR value format",
	warrantyWarningDays: "Warranty warning days",
	expirationWarningDays: "Expiration warning days",
	inspectionWarningDays: "Inspection warning days",
	autoCreateBookableResources: "Automatically create bookable resources when product rules request it",
	permanentInventoryLink: "Permanent inventory link",
	showQr: "Show QR",
	downloadSvg: "Download SVG",
	reservedQuantity: "Reserved quantity",
	noBookableResource: "This owned item is not a bookable resource.",
	noMovements: "No movements yet.",
	disposalWarning: "This preserves all purchase and movement history, removes available stock, and deactivates any linked bookable resource.",
	quantityChange: "Quantity change (+ or −)",
	issueDescription: "Issue description",
	auditReasonHelp: "The previous and new values, user, and timestamp will be audited.",
	downloadTemplate: "Download template",
	validatePreview: "Validate and preview",
	validation: "Validation",
	valid: "Valid",
	selectInventoryLine: "Select at least one Office inventory line",
	noReceivableOfficeProducts: "This purchase has no receivable products classified as Office inventory.",
	serialNumbersHelp: "One serial number per line (or comma-separated)",
	nextInspection: "Next inspection",
	leaveBlankGenerate: "Leave blank to generate automatically",
	expectedMonthlyUsage: "Expected monthly usage",
	expectedUsefulLifeMonths: "Expected useful life (months)",
	warrantyDurationMonths: "Warranty duration (months)",
	maintenanceIntervalDays: "Maintenance interval (days)",
	inspectionIntervalDays: "Inspection interval (days)",
	productPurposeHelp: "A product is something the company can buy; owned records are created only when a purchase is received.",
	safetyCompliance: "Safety / Compliance",
	adjust: "Adjust",
	assign: "Assign",
	available: "Available",
	bookable: "Bookable",
	desk: "Desk",
	dispose: "Dispose",
	documents: "Documents",
	expirationDate: "Expiration date",
	floor: "Floor",
	inspection: "Inspection",
	minimumQuantity: "Minimum quantity",
	no: "No",
	notFound: "Not found",
	notes: "Notes",
	office: "Office",
	purchase: "Purchase",
	purchaseDate: "Purchase date",
	reason: "Reason",
	receivedDate: "Received date",
	reorderQuantity: "Reorder quantity",
	resources: "Resources",
	select: "Select",
	serialNumber: "Serial number",
	shopPurchase: "Purchase",
	stock: "Stock",
	subcategory: "Subcategory",
	transfer: "Transfer",
	unit: "Unit",
	viewPurchase: "View purchase",
	warranty: "Warranty",
	print: "Print",
	selectAllInventory: "Select all inventory items",
	chooseXlsxFile: "Choose .xlsx file",
	importPreviewSummary: "{total} row(s): {valid} valid, {invalid} with errors. Invalid rows will not be imported.",
	importValidRows: "Import {count} valid row(s)",
	receiptReplay: "This receipt had already completed; the original result is shown.",
	inventoryRecordsCreated: "{count} inventory record(s) created or updated.",
	remaining: "remaining",
	assetNumbersHelp: "One asset number per line (or comma-separated)",
	fieldIsRequired: "{field} is required",
	actualVacation: "Vacation",
	vacationPlanning: "Vacation planning",
	vacationPlanningPresentationHint: "Planning only — this date range does not change attendance, payroll, or vacation balance.",
	vacationPlanningSaved: "Vacation planning saved",
	vacationPlanningRemoved: "Vacation planning removed",
	attendanceLastRefreshed: "Last refreshed",
	todoMuteNotifications: "Mute notifications",
	todoUnmuteNotifications: "Unmute notifications",
	todoMuteFor: "Mute notifications for",
	todoMuteForever: "Forever",
	todoCustomMinutes: "Custom duration (minutes)",
	todoMutedUntil: "Muted until",
	todoMutedForever: "Muted forever",
	todoNotificationsMuted: "Notifications muted",
	todoNotificationsUnmuted: "Notifications unmuted",
	todoNotificationMuteFailed: "Could not update notification mute",
	todoEmptyColumnNotifications: "Empty-column notifications",
	todoNotifyWhenColumnEmpty: "Notify when this column stays empty",
	todoEmptyForMinutes: "Empty time (minutes)",
	todoEmptyForMinutesDescription: "Send the alert after the column has had no active task cards for this long.",
	todoAdditionalNotifyUsers: "Additional users to notify",
	todoAdditionalNotifyUsersDescription: "Only board members can be selected. Responsible users are included automatically.",
	todoResponsibleAlwaysNotified: "Responsible users are always notified",
	todoEmptyColumnBypassesMute: "This deadline alert has priority and is delivered even when the board or task is muted.",
	todoEmptyColumnMinutesRequired: "Enter an empty time of at least one minute.",
	todoEmptyColumnRuleSaved: "Empty-column notification rule saved",
	todoEmptyColumnRuleSaveFailed: "Could not save the empty-column notification rule",
	quarter: "Quarter",
	year: "Year",
	currentQuarter: "Current Quarter",
	currentYear: "Current Year",
	chatBlockedSection: "Blocked contacts",
	chatBlockUserConfirm: "Block this user? They won't be able to message you in this chat.",
};
